const STRAINS = [
  'Lactobacillus lactis','Bifidobacterium bifidum','Ligilactobacillus salivarius',
  'Bifidobacterium breve','Saccharomyces cerevisiae','Lactobacillus bulgaricus',
  'Lactobacillus delbrueckii','Bifidobacterium animalis','Bifidobacterium longum',
  'Lactiplantibacillus plantarum','Limosilactobacillus reuteri','Lactobacillus helveticus',
  'Lactobacillus johnsonii','Bacillus clausii','Lactobacillus gasseri','Bifidobacterium infantis',
  'Levilactobacillus brevis','Lacticaseibacillus paracasei','Bacillus coagulans','Bacillus indicus'
];
const DEFAULT_STRAINS=[2,3,6,15,18]; // used when <6 triggered

// Strain benefit descriptions
const STRAIN_BENEFIT={
  0:'Supports gut barrier integrity and reduces food sensitivity reactions.',
  1:'Boosts immune response and reduces systemic inflammation.',
  2:'Protects gut lining and supports hair follicle nourishment.',
  3:'Regulates fat metabolism and supports healthy bowel transit.',
  4:'Restores microbiome diversity post-antibiotic use.',
  5:'Supports lactose digestion and healthy stool consistency.',
  6:'Promotes regularity and reduces fermentation-caused gas.',
  7:'Reduces bloating and supports large intestine motility.',
  8:'Heals gut permeability; supports immune and hormonal balance.',
  9:'Reduces gut pain and inflammation; supports stomach lining.',
  10:'Supports acid reflux relief and gut-brain communication.',
  11:'Reduces stress-related gut symptoms; supports sleep quality.',
  12:'Improves cognitive clarity and reduces brain fog via gut-brain axis.',
  13:'Restores bacterial balance; effective for post-antibiotic recovery.',
  14:'Reduces acid reflux severity and supports upper-GI comfort.',
  15:'Supports fat metabolism and healthy weight management.',
  16:'Reduces gas and bloating from fermentation.',
  17:'Supports fat metabolism and calorie processing efficiency.',
  18:'Broad-spectrum gut health support; effective for IBS and brain fog.',
  19:'Reduces loose motions and restores bowel consistency.'
};

// ── QUESTION BANK ──

const EXPERT_PICS={
  max:{img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/156.jpg?v=1776677665',name:'Max Kushnir',role:'CSO & Co-Founder'},
  gargi:{img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/155.jpg?v=1776677665',name:'Gargi Sareen',role:'Head, Gut Health Expert'},
  simran:{img:'https://cdn.shopify.com/s/files/1/0687/4523/2705/files/52.png?v=1768114386',name:'Simran Yadav',role:'Clinical Nutritionist'},
  subhanshu:{img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/154.jpg?v=1776677665',name:'Dr. Subhanshu Gupta',role:'Gastroenterologist'}
};

// ── MOBILE MENU ──
function toggleMenu(){
  document.getElementById('burger').classList.toggle('open');
  document.getElementById('mobMenu').classList.toggle('open');
  document.body.style.overflow=document.getElementById('mobMenu').classList.contains('open')?'hidden':'';
}

// ── HERO (bg stays fixed, only text cycles) ──
const slides=[
  {tag:'Made for your digestive problems',k:'Not a generic supplement. Made only for your digestive problems.',h:'Your gut\'s missing<br>ingredients —<br><span class="hi">delivered to you.</span>',sub:'Sova X identifies exactly which bacteria your gut is missing and makes a supplement only for that. Not off a shelf. Made in a lab, only for you.'},
  {tag:'Acidity & Reflux fixed',k:'One sachet a day. Acidity relief in 7 days. Fixed for good in 90.',h:'End the acidity<br>and reflux<br><span class="hi">for good.</span>',sub:'Sova X identifies the exact bacteria causing your acidity and targets them — not just the symptom. Fix the root cause, not just the acid.'},
  {tag:'Bloating & Constipation fixed',k:'One sachet a day. Bloating gone in 7 days. Fixed for good in 90.',h:'Stop the bloating<br>and constipation<br><span class="hi">cycle.</span>',sub:'Probiotic strains begin colonizing from your first dose. Visible relief by Week 1 as your gut bacteria rebalance — lasting root-cause fix by Day 90.'}
];
let cur=0,tmr;
function goSlide(n){
  document.querySelectorAll('.hd').forEach((d,i)=>d.classList.toggle('on',i===n));
  const s=slides[n];cur=n;
  document.getElementById('hftag').textContent=s.tag;
  document.getElementById('hk').textContent=s.k;
  document.getElementById('hh').innerHTML=s.h;
  document.getElementById('hsub').textContent=s.sub;
}
tmr=setInterval(()=>goSlide((cur+1)%3),5500);
document.querySelectorAll('.hd').forEach((d,i)=>d.addEventListener('click',()=>{clearInterval(tmr);goSlide(i);tmr=setInterval(()=>goSlide((cur+1)%3),5500);}));

// ── SHOPIFY GALLERY ──
const pdpImgs=['https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Hero_Catalog_1.png?v=1778784461&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_2.png?v=1778784461&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_3.png?v=1778784461&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_4.png?v=1778784461&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_5.png?v=1778784461&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_6.png?v=1778784462&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_7.png?v=1778784462&width=1000','https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Catalog_8.png?v=1778784462&width=1000'];
let pdpCur=0;
function pdpGoto(n){
  pdpCur=n;
  const img=document.getElementById('pdp-main-img');
  img.classList.add('fade');
  setTimeout(()=>{img.src=pdpImgs[n];img.onload=()=>img.classList.remove('fade');},200);
  document.querySelectorAll('.pdp-th').forEach((t,i)=>t.classList.toggle('active',i===n));
  document.getElementById('pdp-cur').textContent=n+1;
  document.querySelectorAll('.pdp-th')[n].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
}
function pdpNav(d){pdpGoto((pdpCur+d+pdpImgs.length)%pdpImgs.length);}
(()=>{const el=document.querySelector('.pdp-main');let sx=0;el.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});el.addEventListener('touchend',e=>{if(Math.abs(e.changedTouches[0].clientX-sx)>40)pdpNav(e.changedTouches[0].clientX<sx?1:-1);});})();

// ── PRODUCT TABS ──
function swPTab(id,el){
  document.querySelectorAll('.ptab').forEach(b=>b.classList.remove('on'));
  el.classList.add('on');
  document.querySelectorAll('.ptab-c').forEach(c=>c.classList.remove('on'));
  document.getElementById('pt-'+id).classList.add('on');
}

// ── INGREDIENT CARDS (mobile toggle) ──
function togglePI(card){
  if(window.innerWidth>768)return; // desktop = CSS :hover only
  const wasOpen=card.classList.contains('mob-open');
  // Close ALL cards
  document.querySelectorAll('.pi-probiotic,.pi-mct-solo').forEach(c=>{
    c.classList.remove('mob-open');
  });

  // Open this card if it wasn't already open
  if(!wasOpen){
    card.classList.add('mob-open');
    // If it's in the bottom row, expand the row height too
    if(card.classList.contains('pi-mct')){
    }
  }
}
function toggleIC(card){togglePI(card);}// legacy alias
// ── HUB CARD EXPAND (legacy) ──
function toggleHub(card){
  const expand=card.querySelector('.hub-expand');
  if(!expand)return;
  const isOpen=expand.style.display!=='none';
  document.querySelectorAll('.hub-card').forEach(c=>{const e=c.querySelector('.hub-expand');if(e)e.style.display='none';c.style.boxShadow='';});
  if(!isOpen){expand.style.display='block';card.style.boxShadow='var(--sh2)';}
}
// ── WIW COLLAPSIBLE ──
function toggleWiw(head){
  const item=head.closest('.wiw-item');
  const isOpen=item.classList.contains('open');
  document.querySelectorAll('.wiw-item').forEach(i=>i.classList.remove('open'));
  if(!isOpen)item.classList.add('open');
}
// ── INGREDIENT COLLAPSIBLES ──
function toggleColl(head){
  const item=head.closest('.coll-item');
  item.classList.toggle('open');
}
function toggleHM(head){
  const item=head.closest('.hm-item');
  item.classList.toggle('open');
}

// ── CHART ──
const COLORS={bloating:'#0EAD85',constipation:'#E8873A',acidity:'#E05A7A',ibs:'#7B68D4',energy:'#F0B429',skin:'#4BB38A'};
const LABELS=['Wk 1','Wk 2','Wk 3','Wk 4','Wk 5','Wk 6','Wk 7','Wk 8','Wk 9','Wk 10','Wk 11','Wk 12'];
const NAMES={bloating:'Bloating & Gas',constipation:'Constipation',acidity:'Acidity & Reflux',ibs:'IBS & Cramps',energy:'Energy & Mood',skin:'Skin Issues'};
const BASE={bloating:[100,72,62,51,40,31,24,18,13,10,8,7],constipation:[100,84,74,64,52,41,33,26,20,15,12,10],acidity:[100,74,64,54,43,34,26,20,15,11,8,7],ibs:[100,90,82,72,61,50,41,33,26,20,16,14],energy:[100,92,85,76,66,55,45,37,30,24,19,17],skin:[100,96,90,82,72,61,51,42,34,27,22,19]};
function getDysbiosis(n){
  if(n<=1)return BASE;
  const f=n===2?1.07:n===3?1.13:1.19;
  const r={};
  Object.keys(BASE).forEach(k=>{r[k]=BASE[k].map((v,i)=>Math.min(100,Math.max(5,Math.round(v*(i<3?f:i<6?f*.97:i<9?1.01:.97)))));});
  return r;
}
const PHASES=[{start:0,end:0,color:'rgba(14,173,133,.07)'},{start:1,end:3,color:'rgba(14,173,133,.04)'},{start:4,end:7,color:'rgba(14,173,133,.03)'},{start:8,end:11,color:'rgba(14,173,133,.02)'}];
let chart;
function buildChart(){
  const active=Array.from(document.querySelectorAll('.sym-btn.on')).map(b=>b.dataset.sym);
  const n=active.length;
  const data=getDysbiosis(n);
  document.getElementById('dysbadge').classList.toggle('vis',n>=3);
  if(n>=3){const m={3:'3 symptoms — moderate dysbiosis. Deeper curve, stronger results from week 5+.',4:'4+ symptoms — significant dysbiosis. Gut test path strongly recommended.',5:'5+ symptoms — high dysbiosis. Full stool analysis will significantly optimize your formula.'};document.getElementById('dysbadge-text').textContent=m[Math.min(n,5)]||m[5];}
  const datasets=active.map(k=>({label:NAMES[k],data:data[k],borderColor:COLORS[k],backgroundColor:COLORS[k]+'14',tension:.42,borderWidth:2.5,pointRadius:3.5,pointHoverRadius:6,pointBackgroundColor:COLORS[k],pointBorderColor:'#fff',pointBorderWidth:2,fill:true}));
  if(chart)chart.destroy();
  const ctx=document.getElementById('symChart').getContext('2d');
  const phPlugin={id:'ph',beforeDraw(c){const{ctx,chartArea,scales}=c;if(!chartArea)return;PHASES.forEach(ph=>{const x0=scales.x.getPixelForValue(ph.start),x1=scales.x.getPixelForValue(ph.end);ctx.fillStyle=ph.color;ctx.fillRect(x0,chartArea.top,(ph.end===11?chartArea.right:x1)-x0,chartArea.bottom-chartArea.top);if(ph.end<11){ctx.save();ctx.strokeStyle='rgba(14,173,133,.12)';ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(x1,chartArea.top);ctx.lineTo(x1,chartArea.bottom);ctx.stroke();ctx.restore();}});} };
  chart=new Chart(ctx,{type:'line',data:{labels:LABELS,datasets},options:{responsive:true,maintainAspectRatio:false,animation:{duration:600,easing:'easeInOutQuart'},plugins:{legend:{position:'bottom',labels:{boxWidth:12,padding:22,color:'#6A6560',font:{family:'DM Sans',size:12},usePointStyle:true,pointStyle:'circle'}},tooltip:{backgroundColor:'rgba(28,26,22,.9)',titleColor:'#F7F5F0',bodyColor:'#A09C96',padding:12,cornerRadius:8,callbacks:{label:c=>`${c.dataset.label}: ${c.raw}% severity`,title:t=>`${t[0].label} of treatment`}}},scales:{y:{min:0,max:105,ticks:{callback:v=>v+'%',color:'#A09C96',font:{size:11},maxTicksLimit:6},grid:{color:'rgba(28,26,22,.05)'},title:{display:true,text:'Symptom severity',color:'#A09C96',font:{size:12,family:'DM Sans'}}},x:{ticks:{color:'#A09C96',font:{size:11}},grid:{display:false}}}},plugins:[phPlugin]});
}
function toggleSym(btn){
  const on=btn.classList.contains('on');
  if(on&&document.querySelectorAll('.sym-btn.on').length===1)return;
  btn.classList.toggle('on');
  const sym=btn.dataset.sym;
  if(btn.classList.contains('on')){btn.style.background=COLORS[sym];btn.style.color='#fff';btn.style.borderColor='transparent';btn.querySelector('.sb-dot').style.background='rgba(255,255,255,.5)';}
  else{btn.style.background='';btn.style.color='';btn.style.borderColor='';btn.querySelector('.sb-dot').style.background=COLORS[sym];}
  buildChart();
}
window.addEventListener('load',buildChart);

// ── TESTIMONIALS CAROUSEL ──
let revCur=0;
const revData=[0,1,2,3,4,5,6,7,8];
function setupRevCarousel(){
  const track=document.getElementById('revTrack');
  const cards=track.querySelectorAll('.rc');
  const dots=document.getElementById('revDots');
  dots.innerHTML='';
  const perView=window.innerWidth<768?1:3;
  const total=Math.ceil(cards.length/perView);
  for(let i=0;i<total;i++){const d=document.createElement('div');d.className='rd'+(i===0?' on':'');d.onclick=()=>revGoTo(i);dots.appendChild(d);}
  revGoTo(0,true);
}
function revGoTo(n,init){
  const track=document.getElementById('revTrack');
  const cards=track.querySelectorAll('.rc');
  const perView=window.innerWidth<768?1:3;
  const cardW=cards[0].offsetWidth+16;
  const total=Math.ceil(cards.length/perView);
  revCur=Math.max(0,Math.min(n,total-1));
  track.style.transform=`translateX(-${revCur*(cardW*perView)}px)`;
  document.querySelectorAll('.rd').forEach((d,i)=>d.classList.toggle('on',i===revCur));
}
function revSlide(d){
  const track=document.getElementById('revTrack');
  const cards=track.querySelectorAll('.rc');
  const perView=window.innerWidth<768?1:3;
  const total=Math.ceil(cards.length/perView);
  revGoTo((revCur+d+total)%total);
}
window.addEventListener('load',setupRevCarousel);
window.addEventListener('resize',setupRevCarousel);

// ── CLINICAL CAROUSEL ──
(function(){
  const track=document.getElementById('clinTrack');
  const nav=document.getElementById('clinNav');
  const cards=track.querySelectorAll('.cc');
  const perView=()=>window.innerWidth<768?1:window.innerWidth<1024?2:3;
  let cur=0;
  function setup(){
    nav.innerHTML='';
    const n=Math.ceil(cards.length/perView());
    for(let i=0;i<n;i++){const d=document.createElement('div');d.className='cn-dot'+(i===0?' on':'');d.onclick=()=>go(i);nav.appendChild(d);}
    go(0,true);
  }
  function go(n){
    cur=n;
    const cw=cards[0].offsetWidth+20;
    track.style.scrollBehavior='smooth';
    track.scrollLeft=cur*cw*perView();
    document.querySelectorAll('.cn-dot').forEach((d,i)=>d.classList.toggle('on',i===cur));
  }
  window.addEventListener('load',setup);
  window.addEventListener('resize',setup);
  // drag
  let mx=false,sx=0,sl=0;
  track.addEventListener('mousedown',e=>{mx=true;sx=e.pageX-track.offsetLeft;sl=track.scrollLeft;track.classList.add('drag')});
  track.addEventListener('mouseleave',()=>{mx=false;track.classList.remove('drag')});
  track.addEventListener('mouseup',()=>{mx=false;track.classList.remove('drag')});
  track.addEventListener('mousemove',e=>{if(!mx)return;e.preventDefault();track.scrollLeft=sl-(e.pageX-track.offsetLeft-sx);});
})();

// ── FAQ ──
function togFaq(btn){const item=btn.closest('.fi');const was=item.classList.contains('op');document.querySelectorAll('.fi').forEach(i=>i.classList.remove('op'));if(!was)item.classList.add('op');}

// ── MODAL ──
function openModal(){document.getElementById('modal').classList.add('open');document.body.style.overflow='hidden';showPlansView();}
function openFunnel(){document.getElementById('modal').classList.add('open');document.body.style.overflow='hidden';showFunnelView();}
function closeModal(){document.getElementById('modal').classList.remove('open');document.body.style.overflow='';}
function showPlansView(){document.getElementById('mv-plans').classList.add('on');document.getElementById('mv-funnel').classList.remove('on');}
function showFunnelView(){document.getElementById('mv-plans').classList.remove('on');document.getElementById('mv-funnel').classList.add('on');}
document.getElementById('modal').addEventListener('click',function(e){if(e.target===this)closeModal();});
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeModal();});

// ── MODAL FUNNEL ──
const mAns={};
function mUpdProg(n){for(let i=1;i<=4;i++)document.getElementById('mp'+i).classList.toggle('done',i<=n);}
function mAnsQ(q,v,el){
  mAns['q'+q]=v;
  el.parentElement.querySelectorAll('.fopt').forEach(o=>o.classList.remove('sel'));
  el.classList.add('sel');
  setTimeout(()=>{
    if(q===1){document.getElementById('mfq1').classList.remove('on');document.getElementById('mfq2').classList.add('on');mUpdProg(2);}
    else if(q===2){document.getElementById('mfq2').classList.remove('on');document.getElementById('mfq3').classList.add('on');mUpdProg(3);}
    else{document.getElementById('mfq3').classList.remove('on');document.getElementById('mflead').classList.add('on');mUpdProg(4);}
  },320);
}
function mSubmitLead(){
  if(!document.getElementById('mlp').value){document.getElementById('mlp').style.borderColor='#dc3545';return;}
  document.getElementById('mflead').classList.remove('on');
  document.getElementById('mfres').classList.add('on');mUpdProg(4);
  const heavy=mAns.q2==='chronic'||mAns.q3==='failed'||mAns.q1==='multiple'||mAns.q2==='long';
  if(heavy){
    document.getElementById('mrh').textContent='We recommend the At-home Gut Test Formula';
    document.getElementById('mrp').textContent='Based on your symptoms and history, a clinical gut test will give us the most accurate picture — enabling a 31-ingredient formula built from real lab data.';
    document.getElementById('mrcard').style.borderColor='var(--gold)';document.getElementById('mrtag').style.color='var(--gold)';
    document.getElementById('mracts').innerHTML=`<button class="float-btn" style="position:static;background:var(--gold);box-shadow:none;padding:13px 22px;font-size:14px" onclick="closeModal();startStoolTest()">Order gut test kit →</button><button onclick="showPlansView()" style="padding:13px 22px;font-size:14px;background:var(--bg);border:1px solid var(--bdr2);border-radius:100px;cursor:pointer;color:var(--t2)">Compare plans</button>`;
  }
}
// startAssessment() defined in quiz engine below
function startStoolTest(){alert('→ Opens stool test checkout flow\n[Wire: Shopify checkout or consult booking]');}

// ── HOW IT WORKS TABS ──
function swTab(t,el){document.querySelectorAll('.htab').forEach(b=>b.classList.remove('on'));el.classList.add('on');document.getElementById('hca').classList.toggle('on',t==='a');document.getElementById('hcs').classList.toggle('on',t==='s');}

// ── EVENT TRACKING ──
const _dl = window.dataLayer = window.dataLayer||[];
const _fbq = window.fbq||function(){};

function trackEvent(eventName, params){
  // GTM dataLayer push
  _dl.push({event:eventName,...params});
  // Meta Pixel custom event
  try{fbq('trackCustom',eventName,params);}catch(e){}
}

// Auto-track all CTA button clicks
document.addEventListener('click',function(e){
  const btn = e.target.closest('button,a[onclick]');
  if(!btn)return;
  const label = (btn.textContent||'').trim().replace(/\s+/g,' ').slice(0,80);
  const id = btn.id||btn.className||'';
  trackEvent('button_click',{button_label:label,button_id:id,page_section:getSection(btn)});

  // Specific high-value events
  if(label.toLowerCase().includes('gut assessment')||label.toLowerCase().includes('personalized gut')){
    trackEvent('InitiateCheckout',{content_name:'Gut Assessment CTA',value:5997,currency:'INR'});
    try{fbq('track','InitiateCheckout',{value:5997,currency:'INR',content_name:'SovaX Assessment'});}catch(e){}
  }
  if(btn.id==='modal'||btn.onclick&&btn.onclick.toString().includes('openModal')){
    trackEvent('ViewContent',{content_name:'Modal Opened',content_category:'Conversion'});
  }
});

function getSection(el){
  const sec = el.closest('[id]');
  return sec?sec.id:'page';
}

// Modal open/close tracking
const _origOpen = window.openModal;
window.openModal = function(){
  trackEvent('modal_open',{modal:'plans_view'});
  try{fbq('track','ViewContent',{content_name:'SovaX Modal',content_category:'Conversion'});}catch(e){}
  if(_origOpen)_origOpen();
};
const _origClose = window.closeModal;
window.closeModal = function(){
  trackEvent('modal_close',{modal:'plans_view'});
  if(_origClose)_origClose();
};

// Scroll depth tracking
let scrollMilestones={25:false,50:false,75:false,90:false};
window.addEventListener('scroll',function(){
  const pct=Math.round((window.scrollY/(document.body.scrollHeight-window.innerHeight))*100);
  [25,50,75,90].forEach(m=>{
    if(pct>=m&&!scrollMilestones[m]){
      scrollMilestones[m]=true;
      trackEvent('scroll_depth',{depth:m+'%'});
    }
  });
},{passive:true});

// Time on page
let _timeStart=Date.now();
window.addEventListener('beforeunload',function(){
  const secs=Math.round((Date.now()-_timeStart)/1000);
  navigator.sendBeacon&&navigator.sendBeacon('/beacon',JSON.stringify({event:'time_on_page',seconds:secs}));
  trackEvent('time_on_page',{seconds:secs});
});

console.log('[SovaX] Event tracking initialized — GTM-PJLTMV9 + Meta Pixel 1945467919635390');
const ro=new IntersectionObserver(e=>e.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');ro.unobserve(e.target);}}),{threshold:0.08});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

/* ═══════════════════════════════════════
   SOVA X ASSESSMENT ENGINE
   ═══════════════════════════════════════ */

// ── STRAIN REGISTRY ──

const QUESTIONS=[
  // SECTION 0 — PROFILING
  {id:'contact',sec:0,type:'contact',
    q:'Welcome! Let\'s start with your details.',
    sub:'This personalizes your formula report and allows us to send your results.',
    // Collects name, phone, email in one screen
  },
  {id:'basics',sec:0,type:'basics',
    q:'Tell us about yourself',
    sub:'Used to calculate your BMI for dosage calibration. None of this is shown publicly.',
    // Collects age, weight, height in one screen
  },
  {id:'gender',sec:0,type:'single',q:'How do you identify?',
    opts:['Male','Female','Other / Prefer not to say'],
    tags:[null,null,null],strains:[[],[],[]]},
  {id:'city',sec:0,type:'text',q:'Which city are you in?',ph:'Your City',
    sub:'Dietary patterns and water quality vary by region — this helps us calibrate your formula.',key:'city'},

  // SECTION BREAK — SYMPTOMS
  {id:'_break_symptoms',sec:1,type:'sectionbreak',
    title:'Section 2: Symptoms',
    desc:'Next, we\'ll ask about your digestive symptoms and health concerns. Be honest — the more accurate your answers, the more precise your formula.',
    icon:'gut',count:'9 questions'},

  // SECTION 1 — SYMPTOMS
  {id:'stool_freq',sec:1,type:'single',
    q:'In the last 7 days, how many times did you have bowel movements per day?',
    expert:{text:'Frequency is a key indicator of gut transit speed. The optimal range is 1–3 times per day. Going above or below is often the first measurable signal of microbiome imbalance.',expert:'max'},
    opts:['7 or more times per day','4–6 times per day','1–3 times per day (healthy range)'],
    tags:[null,null,null],strains:[[],[],[]]},
  {id:'stool_type',sec:1,type:'bristol',
    q:'Which stool type was most common for you in the last 7 days?',
    sub:'Use the images to identify your type — this is the most diagnostically important question.',
    expert:{text:'The Bristol Stool Chart is a gold-standard clinical diagnostic tool. Types 1–2 = constipation. Types 3–4 = ideal. Types 5–7 = loose motions. Your answer here directly determines specific probiotic strains in your formula.',expert:'subhanshu'},
    opts:[
      {label:'Type 1',desc:'Separate hard lumps — like nuts',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_1.png?v=1776664790',tag:'Constipation',strains:[1,4,6,8,16]},
      {label:'Type 2',desc:'Lumpy sausage shape',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_2.png?v=1776664790',tag:'Constipation',strains:[1,4,6,8,16]},
      {label:'Type 3',desc:'Sausage with cracks — near ideal',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_3.png?v=1776664790',tag:null,strains:[]},
      {label:'Type 4',desc:'Smooth, soft sausage — ideal',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_4.png?v=1776664790',tag:null,strains:[]},
      {label:'Type 5',desc:'Soft blobs, clear edges',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_5.png?v=1776664789',tag:'Diarrhea',strains:[19]},
      {label:'Type 6',desc:'Fluffy pieces — mushy',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_6.png?v=1776664790',tag:'Diarrhea',strains:[5,10,19]},
      {label:'Type 7',desc:'Entirely liquid — no solid pieces',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/Type_7.png?v=1776664789',tag:'Diarrhea',strains:[5,10,19]}
    ]},
  {id:'bother',sec:1,type:'bother',
    q:'How much do each of these gut symptoms affect you?',
    sub:'Rate each from most severe to none. Your answers calibrate the exact strain concentrations.',
    expert:{text:'Severity calibrates your formula dosage. A mild bloating issue and a severe one need different strain concentrations — this is what separates Sova X from generic supplements.',expert:'gargi'},
    symptoms:[
      {id:'b_bloat',label:'Bloating & Gas',tag:'Bloating & Gas',
        strains:{'Very much':[7,10,16,19],'Somewhat':[7,16],'Slightly':[],'Not at all':[]}},
      {id:'b_acid',label:'Acid Reflux / Acidity',tag:'Acid Reflux/Acidity',
        strains:{'Very much':[11,14],'Somewhat':[14],'Slightly':[],'Not at all':[]}},
      {id:'b_const',label:'Constipation',tag:'Constipation',
        strains:{'Very much':[1,4,6,8,16],'Somewhat':[4,8],'Slightly':[],'Not at all':[]}},
      {id:'b_diarr',label:'Diarrhea / Loose Motions',tag:'Diarrhea',
        strains:{'Very much':[5,10,19],'Somewhat':[19],'Slightly':[],'Not at all':[]}},
      {id:'b_both',label:'Both Constipation & Diarrhea',tag:'Constipation & Diarrhea',
        strains:{'Very much':[1,4,5,8,10,16,19],'Somewhat':[4,5,16],'Slightly':[],'Not at all':[]}},
      {id:'b_cramp',label:'Stomach Pain / Gut Cramps',tag:'Gut Barrier',
        strains:{'Very much':[9,10],'Somewhat':[10],'Slightly':[],'Not at all':[]}},
      {id:'b_food',label:'Food Sensitivities / Intolerances',tag:'Food Sensitivities',
        strains:{'Very much':[1],'Somewhat':[1],'Slightly':[],'Not at all':[]}}
    ]},
  {id:'illness',sec:1,type:'single',
    q:'How many times have you fallen ill (cold, flu, infections) in the last 12 months?',
    expert:{text:'Your immune system is 70% gut-based. Frequent illness is a measurable sign of depleted Bifidobacterium populations — your first line of immune defence lives in your gut.',expert:'subhanshu'},
    opts:['7 or more times','4–6 times','0–3 times'],
    tags:['Immunity','Immunity',null],strains:[[2,6,9,13],[2,6],[]]},
  {id:'hair_skin',sec:1,type:'multi',
    q:'How would you describe your current hair and skin health?',
    sub:'Select all that apply.',
    expert:{text:'The gut-skin axis is scientifically established. Gut dysbiosis drives systemic inflammation that shows up as acne, dull skin, and hair thinning. Specific probiotic strains reduce this inflammatory cascade.',expert:'gargi'},
    opts:[
      {label:'Frequent hair fall or thinning',tag:'Inner Beauty',strains:[2]},
      {label:'Dry, brittle, or dull hair',tag:'Inner Beauty',strains:[2]},
      {label:'Skin issues: dryness, acne, or dullness',tag:null,strains:[]},
      {label:'Hair and skin feel healthy and well-maintained',tag:null,strains:[]},
      {label:'No big concerns — just maintaining my routine',tag:null,strains:[]}
    ]},
  {id:'weight_change',sec:1,type:'single',
    q:'Which best describes your experience with weight and body composition?',
    expert:{text:'Gut bacteria regulate fat storage, hunger hormones, and calorie processing. Lactobacillus gasseri has demonstrated significant reductions in visceral belly fat in clinical trials.',expert:'max'},
    opts:[
      'I gain weight easily, even with minor diet slips',
      'I struggle to lose fat despite consistent effort',
      'I notice fat mostly around belly, hips, or thighs',
      'I manage my weight well with my current routine'
    ],
    tags:['Fat Metabolism','Fat Metabolism','Fat Metabolism',null],
    strains:[[4,15,18],[4,15,18],[15,18],[]]},
  {id:'metabolic',sec:1,type:'multi',
    q:'Are you currently managing any of these health conditions?',
    sub:'Select all that apply.',
    expert:{text:'Metabolic conditions have strong gut-microbiome links. Specific Lactiplantibacillus and Bifidobacterium strains improve insulin sensitivity, reduce LDL, and modulate hormones disrupted in PCOS.',expert:'simran'},
    opts:[
      {label:'PCOS / PCOD',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'High cholesterol',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'Obesity / Overweight',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'High blood pressure (Hypertension)',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'Type 2 Diabetes / Insulin Resistance',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'Thyroid imbalance (Hypo or Hyperthyroidism)',tag:'Metabolic Health',strains:[1,8,10,15]},
      {label:'Currently healthy — none of the above',tag:null,strains:[],exclusive:true}
    ]},

  // SECTION BREAK — LIFESTYLE
  {id:'_break_lifestyle',sec:2,type:'sectionbreak',
    title:'Section 3: Lifestyle',
    desc:'Last section! These questions help us understand how your daily habits affect your gut microbiome. Almost there.',
    icon:'lifestyle',count:'8 questions'},

  // SECTION 2 — LIFESTYLE
  {id:'antibiotics',sec:2,type:'single',
    q:'How many courses of antibiotics have you taken in the last 12 months?',
    expert:{text:'Antibiotics are the single biggest disruptor of the gut microbiome. A single course wipes 30–40% of gut bacteria — including beneficial strains that take months to recover naturally.',expert:'subhanshu'},
    opts:['7 or more courses','4–6 courses','0–3 courses'],
    tags:['Post Antibiotic Recovery','Post Antibiotic Recovery',null],
    strains:[[1,5,8,9],[1,5],[]]},
  {id:'stress',sec:2,type:'single',
    q:'How emotionally balanced and steady have you felt in the last 30 days?',
    expert:{text:'Cortisol directly suppresses Lactobacillus populations and increases gut permeability. The gut-brain axis is bidirectional — stress disrupts your gut, and a disrupted gut amplifies anxiety.',expert:'simran'},
    opts:['Extremely balanced and calm','Neutral — some stress but manageable','Not balanced at all — frequently stressed or anxious'],
    tags:[null,'Stress & Anxiety','Stress & Anxiety'],
    strains:[[],[11],[9,11,12]]},
  {id:'brain_fog',sec:2,type:'single',
    q:'In the last 10 days, on how many days did you feel mentally foggy or less focused?',
    expert:{text:'Your gut bacteria produce 90% of your body\'s serotonin. Brain fog is often a downstream symptom of gut dysbiosis — specific strains improve GABA and serotonin production via the vagus nerve.',expert:'max'},
    opts:['7 or more days','4–6 days','0–3 days'],
    tags:['Gut Brain Axis','Gut Brain Axis',null],
    strains:[[11,12,18],[11,12],[]]},
  {id:'sleep',sec:2,type:'single',
    q:'Do you find it hard to relax or fall asleep at night?',
    expert:{text:'Sleep and gut health operate in a bidirectional loop. Poor sleep disrupts microbiome diversity within 48 hours. An imbalanced gut impairs melatonin production — because serotonin, which converts to melatonin, is primarily made in your gut.',expert:'gargi'},
    opts:[
      'Yes — I stay up late due to thoughts, screen time, or distractions',
      'Yes — I use medication or supplements to fall asleep',
      'No — I sleep peacefully and wake up refreshed'
    ],
    tags:['Sleep cycle','Sleep cycle',null],
    strains:[[6,9],[2,6,9,12],[]]},
  {id:'fermented',sec:2,type:'single',
    q:'How often do you include fermented foods? (curd, yogurt, buttermilk, idli, kanji, homemade pickles)',
    expert:{text:'Fermented foods are nature\'s probiotics — but they contain generic strains at low CFU counts. They\'re a good foundation but cannot replace clinically targeted strains at therapeutic dosages.',expert:'max'},
    opts:['Daily — in most meals','Frequently: 3–5 times a week','Occasionally: 1–2 times a week','Rarely or never'],
    tags:[null,null,'Fermented Foods','Fermented Foods'],
    strains:[[],[],[1,6],[1,6,7,17]]},
  {id:'prebiotic',sec:2,type:'single',
    q:'Do you regularly eat prebiotic-rich foods? (apples, bananas, ragi, oats, flaxseeds, salads, cooked legumes)',
    expert:{text:'Prebiotics are the food source for probiotic bacteria. Without prebiotics, even the best probiotic strains fail to colonize. Think of probiotics as seeds — prebiotics are the soil.',expert:'simran'},
    opts:['Daily or almost every day','A few times a week (3–4 days)','Rarely or never'],
    tags:[null,null,null],strains:[[],[],[1,6,7,17]]},
  {id:'diet_type',sec:2,type:'single',
    q:'What best describes your typical diet?',
    expert:{text:'Diet shapes your baseline microbiome. Plant-rich diets support higher Bifidobacterium diversity. Your formula is calibrated to compensate for what your diet doesn\'t naturally provide.',expert:'gargi'},
    opts:['Both vegetarian and non-vegetarian','Vegetarian only','Vegan'],
    tags:[null,null,null],strains:[[],[],[]]},
  {id:'meal_quality',sec:2,type:'single',
    q:'How would you describe the overall quality of your typical meals?',
    expert:{text:'Ultra-processed foods cause measurable shifts in gut bacteria within 24 hours — reducing microbial diversity, the single strongest predictor of long-term gut health.',expert:'max'},
    opts:[
      'Mostly home-cooked — plenty of vegetables and whole grains',
      'Simple meals — not much variety in vegetables or carbs',
      'Includes processed or ready-to-eat foods often',
      'Mostly fast food, packaged, or fried meals'
    ],
    tags:[null,null,null,null],strains:[[],[],[],[]]}
]

// ── STATE & SESSION ──
const SS_KEY='sovax_q_v1', SS_RES='sovax_r_v1';
const SECTION_LABELS=['Profiling','Symptoms','Lifestyle'];
let QZ={idx:0,answers:{},multiSel:{},botherSel:{}};

function qzSave(){sessionStorage.setItem(SS_KEY,JSON.stringify({idx:QZ.idx,answers:QZ.answers,multiSel:QZ.multiSel,botherSel:QZ.botherSel}));}
function qzLoad(){try{const d=JSON.parse(sessionStorage.getItem(SS_KEY)||'null');if(d){QZ.idx=d.idx||0;QZ.answers=d.answers||{};QZ.multiSel=d.multiSel||{};QZ.botherSel=d.botherSel||{};}}catch(e){}}

// ── OPEN QUIZ ──
function startAssessment(){
  // Check if results already saved
  try{
    const res=JSON.parse(sessionStorage.getItem(SS_RES)||'null');
    if(res&&res.completedAt){showResultsFromData(res);return;}
  }catch(e){}
  // Load saved progress
  qzLoad();
  // Hide main page
  document.getElementById('qz-ov').style.display='block';
  document.body.style.overflow='hidden';
  // Close modal if open
  closeModal();
  // Track
  trackEvent('assessment_started',{question:0});
  try{fbq('track','InitiateCheckout',{value:5997,currency:'INR',content_name:'SovaX Assessment Start'});}catch(e){}
  qzRender();
}

function qzClose(){
  if(confirm('Are you sure you want to exit? Your progress has been saved.')){
    document.getElementById('qz-ov').style.display='none';
    document.body.style.overflow='';
  }
}

// ── RENDER QUESTION ──
function qzRender(){
  const q=QUESTIONS[QZ.idx];
  const body=document.getElementById('qz-body');
  const realQs=QUESTIONS.filter(x=>!x.id.startsWith('_break_'));
  const realIdx=realQs.findIndex(x=>x.id===q.id);
  const pct=Math.round(((QZ.idx)/QUESTIONS.length)*100);

  // Header
  document.getElementById('qz-prog').style.width=pct+'%';
  if(realIdx>=0) document.getElementById('qz-qcount').textContent=`${realIdx+1} / ${realQs.length}`;
  else document.getElementById('qz-qcount').textContent='';

  // Section tabs
  document.querySelectorAll('.qz-sec').forEach(el=>{
    const s=parseInt(el.dataset.sec);
    el.classList.toggle('active',s===q.sec);
    el.classList.toggle('done',s<q.sec);
  });

  // Nav
  const backBtn=document.getElementById('qz-back');
  backBtn.style.display=QZ.idx===0?'none':'block';
  const nextBtn=document.getElementById('qz-next');
  const isLast=QZ.idx===QUESTIONS.length-1;

  // Section break screen
  if(q.type==='sectionbreak'){
    nextBtn.textContent='Start '+q.title.split(':')[1].trim()+' Questions →';
    nextBtn.disabled=false;
    const icons={gut:'🦠',lifestyle:'🥗'};
    body.innerHTML=`<div class="qz-slide qz-break">
      <div class="qz-break-icon">${icons[q.icon]||'✓'}</div>
      <div class="qz-break-num">${q.title}</div>
      <div class="qz-break-h">${q.desc.split('!')[0]}!</div>
      <div class="qz-break-d">${q.desc}</div>
      <div class="qz-break-badge">${q.count}</div>
    </div>`;
    return;
  }

  nextBtn.textContent=isLast?'See My Formula →':'Continue';
  nextBtn.disabled=!qzHasAnswer(q);

  // Expert tip HTML
  function expertTipHTML(exp){
    if(!exp)return '';
    const ep=EXPERT_PICS[exp.expert]||EXPERT_PICS.max;
    return `<div class="qz-expert">
      <div class="qz-expert-av"><img src="${ep.img}" alt="${ep.name}" loading="lazy" onerror="this.src='https://cdn.shopify.com/s/files/1/0628/8162/8294/files/156.jpg?v=1776677665'"></div>
      <div class="qz-expert-body">
        <div class="qz-expert-name">${ep.name} · ${ep.role}</div>
        <div class="qz-expert-text">${exp.text}</div>
      </div>
    </div>`;
  }

  let html=`<div class="qz-slide">
    <div class="qz-section-tag">${['Profiling','Symptoms','Lifestyle'][q.sec]}</div>
    <div class="qz-q">${q.q}</div>
    ${q.sub?`<div class="qz-sub">${q.sub}</div>`:''}
    ${q.expert?expertTipHTML(q.expert):''}
    <div style="margin-top:20px">`;

  // ── CONTACT SCREEN (name + phone + email) ──
  if(q.type==='contact'){
    const nm=QZ.answers.name||'';
    const ph=QZ.answers.phone||'';
    const em=QZ.answers.email||'';
    html+=`<div class="qz-contact-grid">
      <div class="qz-field">
        <div class="qz-label">Your Name</div>
        <input class="qz-input" id="inp-name" type="text" placeholder="Your Name" value="${nm}" oninput="qzContactChange()">
        <div class="qz-err" id="err-name">Please enter your name</div>
      </div>
      <div class="qz-field">
        <div class="qz-label">Mobile Number</div>
        <div class="qz-ph-wrap">
          <div class="qz-cc">+91</div>
          <input class="qz-ph-input" id="inp-phone" type="tel" placeholder="10-digit number" value="${ph}" maxlength="10" oninput="qzContactChange()">
        </div>
        <div class="qz-err" id="err-phone">Please enter a valid 10-digit number</div>
        <div class="qz-input-hint" style="display:flex;align-items:center;gap:5px;margin-top:6px">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--teal)" stroke-width="2" stroke-linecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <span>Your gut assessment report and personalized probiotic formulation will be sent on this WhatsApp number.</span>
        </div>
      </div>
      <div class="qz-field">
        <div class="qz-label">Email Address</div>
        <input class="qz-input" id="inp-email" type="email" placeholder="you@email.com" value="${em}" oninput="qzContactChange()">
        <div class="qz-err" id="err-email">Please enter a valid email address</div>
      </div>
    </div>`;
  }
  // ── BASICS SCREEN (age + weight + height) ──
  else if(q.type==='basics'){
    const ag=QZ.answers.age||'';const wt=QZ.answers.weight||'';const ht=QZ.answers.height||'';
    html+=`<div class="qz-basics-grid">
      <div class="qz-basics-field">
        <div class="qz-label">Age (years)</div>
        <input class="qz-input" id="inp-age" type="number" placeholder="e.g. 28" value="${ag}" min="10" max="99" oninput="qzBasicsChange()">
        <div class="qz-err" id="err-age">Enter age between 18–99</div>
      </div>
      <div class="qz-basics-field">
        <div class="qz-label">Weight (kg)</div>
        <input class="qz-input" id="inp-weight" type="number" placeholder="e.g. 72" value="${wt}" min="30" max="200" oninput="qzBasicsChange()">
        <div class="qz-err" id="err-weight">Enter weight between 30–200 kg</div>
      </div>
      <div class="qz-basics-field">
        <div class="qz-label">Height (cm)</div>
        <input class="qz-input" id="inp-height" type="number" placeholder="e.g. 168" value="${ht}" min="100" max="250" oninput="qzBasicsChange()">
        <div class="qz-err" id="err-height">Enter height between 100–250 cm</div>
      </div>
    </div>`;
  }
  // ── TEXT INPUT ──
  else if(q.type==='text'||q.type==='email'||q.type==='tel'||q.type==='number'){
    const val=QZ.answers[q.id]||'';
    html+=`<input class="qz-input" id="qz-inp" type="${q.type}" placeholder="${q.ph||''}" value="${val}" 
      oninput="qzInputChange(this.value)" onkeydown="if(event.key==='Enter'&&!document.getElementById('qz-next').disabled)qzNext()">`;
  }
  // ── SINGLE SELECT ──
  else if(q.type==='single'){
    html+=`<div class="qz-opts">`;
    q.opts.forEach((opt,i)=>{
      const sel=QZ.answers[q.id]===i;
      html+=`<button class="qz-opt${sel?' sel':''}" onclick="qzSingle(${i})">
        <div class="qz-opt-circle"></div><span>${opt}</span>
      </button>`;
    });
    html+=`</div>`;
  }
  // ── MULTI SELECT ──
  else if(q.type==='multi'){
    const sel=QZ.multiSel[q.id]||[];
    const is2col=q.id==='metabolic';
    html+=`<div class="qz-opts${is2col?' qz-opts-2col':''}">`;
    q.opts.forEach((opt,i)=>{
      const isS=sel.includes(i);
      html+=`<button class="qz-opt${isS?' sel':''}" onclick="qzMulti(${i})">
        <div class="qz-check"></div><span>${opt.label||opt}</span>
      </button>`;
    });
    html+=`</div>`;
  }
  // ── BRISTOL ──
  else if(q.type==='bristol'){
    const selVal=QZ.answers[q.id];
    html+=`<div class="bristol-grid">`;
    q.opts.forEach((opt,i)=>{
      html+=`<div class="bristol-card${selVal===i?' sel':''}" onclick="qzBristol(${i})">
        <img src="${opt.img}" alt="${opt.label}" loading="lazy">
        <div class="bristol-label">${opt.label}</div>
        <div class="bristol-desc">${opt.desc}</div>
      </div>`;
    });
    html+=`</div>`;
  }
  // ── BOTHER (no Extremely, severe first) ──
  else if(q.type==='bother'){
    const scales=['Very much','Somewhat','Slightly','Not at all'];
    const sel=QZ.botherSel[q.id]||{};
    html+=`<div class="bother-grid">`;
    q.symptoms.forEach((sym,sidx)=>{
      html+=`<div class="bother-row" data-symid="${sym.id}">
        <div class="bother-label" data-symid="${sym.id}">${sym.label} <span style="font-size:11px;font-weight:400;color:var(--t3)">(${sidx+1}/${q.symptoms.length})</span></div>
        <div class="bother-scale">`;
      scales.forEach(s=>{
        const isS=sel[sym.id]===s;
        html+=`<button class="bother-btn${isS?' sel':''}" onclick="qzBother('${sym.id}','${s}')">${s}</button>`;
      });
      html+=`</div></div>`;
    });
    html+=`</div>`;
  }

  html+=`</div></div>`;
  body.innerHTML=html;
  body.scrollTop=0;
  document.getElementById('qz-ov').scrollTop=0;

  // Autofocus
  if(q.type==='contact'){setTimeout(()=>{const i=document.getElementById('inp-name');if(i)i.focus();},100);}
  else if(q.type==='text'||q.type==='email'||q.type==='tel'||q.type==='number'){
    setTimeout(()=>{const i=document.getElementById('qz-inp');if(i)i.focus();},100);
  }
}

function qzHasAnswer(q){
  if(q.type==='sectionbreak')return true;
  if(q.type==='contact'){
    const nm=(QZ.answers.name||'').trim();
    const ph=(QZ.answers.phone||'').trim();
    const em=(QZ.answers.email||'').trim();
    return nm&&/^\d{10}$/.test(ph)&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
  }
  if(q.type==='basics'){
    const a=parseFloat(QZ.answers.age);const w=parseFloat(QZ.answers.weight);const h=parseFloat(QZ.answers.height);
    return a>=18&&a<=99&&w>=30&&w<=200&&h>=100&&h<=250;
  }
  if(q.type==='text'||q.type==='email'||q.type==='tel'||q.type==='number')return !!(QZ.answers[q.id]);
  if(q.type==='single'||q.type==='bristol')return QZ.answers[q.id]!==undefined;
  if(q.type==='multi')return (QZ.multiSel[q.id]||[]).length>0;
  if(q.type==='bother'){
    const sel=QZ.botherSel[q.id]||{};
    return q.symptoms.every(s=>sel[s.id]);
  }
  return false;
}

// ── INPUT HANDLERS ──
function qzContactChange(){
  const nm=(document.getElementById('inp-name')?.value||'').trim();
  const ph=(document.getElementById('inp-phone')?.value||'').trim();
  const em=(document.getElementById('inp-email')?.value||'').trim();
  QZ.answers.name=nm;
  QZ.answers.phone=ph;
  QZ.answers.email=em;
  // Validate
  const phOk=/^\d{10}$/.test(ph);
  const emOk=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
  const errN=document.getElementById('err-name');
  const errP=document.getElementById('err-phone');
  const errE=document.getElementById('err-email');
  if(errN)errN.classList.toggle('vis',!nm&&ph.length>0);
  if(errP)errP.classList.toggle('vis',ph.length>0&&!phOk);
  if(errE)errE.classList.toggle('vis',em.length>0&&!emOk);
  document.getElementById('qz-next').disabled=!(nm&&phOk&&emOk);
  qzSave();
}

function qzBasicsChange(){
  const a=parseFloat(document.getElementById('inp-age')?.value)||0;
  const w=parseFloat(document.getElementById('inp-weight')?.value)||0;
  const h=parseFloat(document.getElementById('inp-height')?.value)||0;
  QZ.answers.age=a||'';QZ.answers.weight=w||'';QZ.answers.height=h||'';
  const errA=document.getElementById('err-age');
  const errW=document.getElementById('err-weight');
  const errH=document.getElementById('err-height');
  if(errA)errA.classList.toggle('vis',a>0&&(a<18||a>99));
  if(errW)errW.classList.toggle('vis',w>0&&(w<30||w>200));
  if(errH)errH.classList.toggle('vis',h>0&&(h<100||h>250));
  document.getElementById('qz-next').disabled=!(a>=18&&a<=99&&w>=30&&w<=200&&h>=100&&h<=250);
  qzSave();
}

function qzInputChange(val){
  const q=QUESTIONS[QZ.idx];
  QZ.answers[q.id]=val.trim();
  document.getElementById('qz-next').disabled=!val.trim();
  qzSave();
}

function qzSingle(i){
  const q=QUESTIONS[QZ.idx];
  QZ.answers[q.id]=i;
  qzSave();
  document.querySelectorAll('.qz-opt').forEach((el,idx)=>{el.classList.toggle('sel',idx===i);});
  document.getElementById('qz-next').disabled=false;
  setTimeout(()=>qzNext(),450);
}

function qzMulti(i){
  const q=QUESTIONS[QZ.idx];
  if(!QZ.multiSel[q.id])QZ.multiSel[q.id]=[];
  const opt=q.opts[i];
  const isExclusive=opt&&opt.exclusive;
  if(isExclusive){QZ.multiSel[q.id]=[i];}
  else{
    QZ.multiSel[q.id]=QZ.multiSel[q.id].filter(x=>!q.opts[x]?.exclusive);
    const pos=QZ.multiSel[q.id].indexOf(i);
    if(pos>=0)QZ.multiSel[q.id].splice(pos,1);else QZ.multiSel[q.id].push(i);
  }
  qzSave();
  const newSel=QZ.multiSel[q.id];
  document.querySelectorAll('.qz-opt').forEach((el,idx)=>{el.classList.toggle('sel',newSel.includes(idx));});
  document.getElementById('qz-next').disabled=newSel.length===0;
}

function qzBristol(i){
  const q=QUESTIONS[QZ.idx];
  QZ.answers[q.id]=i;qzSave();
  document.querySelectorAll('.bristol-card').forEach((el,idx)=>{el.classList.toggle('sel',idx===i);});
  document.getElementById('qz-next').disabled=false;
  setTimeout(()=>qzNext(),480);
}

function qzBother(symId,scale){
  const q=QUESTIONS[QZ.idx];
  if(!QZ.botherSel[q.id])QZ.botherSel[q.id]={};
  QZ.botherSel[q.id][symId]=scale;qzSave();
  // Re-render that row's buttons
  document.querySelectorAll('.bother-row').forEach(row=>{
    const labelEl=row.querySelector('.bother-label');
    const sym=labelEl?.dataset?.symid;
    const syms=sym?q.symptoms.find(s=>s.id===sym):null;
    if(!syms)return;
    row.querySelectorAll('.bother-btn').forEach(btn=>{
      btn.classList.toggle('sel',btn.textContent===QZ.botherSel[q.id][syms.id]);
    });
  });
  const allDone=q.symptoms.every(s=>(QZ.botherSel[q.id]||{})[s.id]);
  document.getElementById('qz-next').disabled=!allDone;
}

// ── NAVIGATION ──
function qzBack(){
  if(QZ.idx>0){QZ.idx--;qzSave();qzRender();}
}

function qzNext(){
  const q=QUESTIONS[QZ.idx];
  if(!qzHasAnswer(q))return;

  // Lead capture after contact screen
  if(q.id==='contact'){qzLeadCapture();}
  // Full profiling enrichment after city (last profiling question)
  if(q.id==='city'){qzProfilingComplete();}
  // Validate contact before allowing advance
  if(q.id==='contact'&&!qzHasAnswer(q)){return;}

  trackEvent('question_answered',{question_id:q.id,section:q.sec,question_num:QZ.idx+1});

  if(QZ.idx<QUESTIONS.length-1){
    QZ.idx++;
    qzSave();
    qzRender();
  } else {
    qzSubmit();
  }
}

// ── SUBMIT & COMPUTE ──
function qzSubmit(){
  // Hide quiz, show loading screen
  document.getElementById('qz-ov').style.display='none';
  document.body.style.overflow='';
  const ld=document.getElementById('qz-loading');
  ld.classList.add('vis');

  // Animate loading steps sequentially
  const steps=[0,1,2,3,4,5];
  steps.forEach((i,idx)=>{
    setTimeout(()=>{
      const el=document.getElementById('ldp'+i);
      if(el)el.classList.add('done');
      // On last step, compute results and show result page
      if(idx===steps.length-1){
        setTimeout(()=>{
          ld.classList.remove('vis');
          const result=qzCompute();
          sessionStorage.setItem(SS_RES,JSON.stringify(result));
          sessionStorage.removeItem(SS_KEY);
          qzLeadEnrich1(result);
          showResultsFromData(result);
        },600);
      }
    },idx*900);
  });
}

function qzCompute(){
  const triggered=new Set();
  const scoreTags=[];
  const SCORED_CATS=['Constipation','Diarrhea','Diarrhea/ Loose motions','Immunity','Inner Beauty',
    'Fat Metabolism','Metabolic Health','Bloating & Gas','Acid Reflux/Acidity',
    'Constipation & Diarrhea','Gut Barrier','Food Sensitivities',
    'Post Antibiotic Recovery','Stress & Anxiety','Gut Brain Axis','Sleep cycle','Fermented Foods'];
  const DEFAULT_STRAINS=[2,3,6,15,18];

  QUESTIONS.forEach(q=>{
    if(q.type==='sectionbreak'||q.type==='contact'||q.type==='basics')return;
    if(q.type==='single'){
      const ans=QZ.answers[q.id];
      if(ans!==undefined&&q.strains&&q.strains[ans]){
        q.strains[ans].forEach(s=>triggered.add(s));
        if(q.tags&&q.tags[ans])scoreTags.push(q.tags[ans]);
      }
    }
    else if(q.type==='bristol'){
      const ans=QZ.answers[q.id];
      if(ans!==undefined&&q.opts[ans]){
        q.opts[ans].strains.forEach(s=>triggered.add(s));
        if(q.opts[ans].tag)scoreTags.push(q.opts[ans].tag);
      }
    }
    else if(q.type==='multi'){
      (QZ.multiSel[q.id]||[]).forEach(i=>{
        const opt=q.opts[i];
        if(opt&&opt.strains)opt.strains.forEach(s=>triggered.add(s));
        if(opt&&opt.tag)scoreTags.push(opt.tag);
      });
    }
    else if(q.type==='bother'){
      const sel=(QZ.botherSel[q.id]||{});
      q.symptoms.forEach(sym=>{
        const scale=sel[sym.id];
        if(scale&&sym.strains[scale]){
          sym.strains[scale].forEach(s=>triggered.add(s));
          if(scale!=='Not at all'&&scale!=='Slightly')scoreTags.push(sym.tag);
        }
      });
    }
  });

  // BMI-based strains
  const w=parseFloat(QZ.answers.weight)||0;
  const h=parseFloat(QZ.answers.height)||0;
  let bmi=0, bmiCat='';
  if(w>0&&h>0){
    bmi=Math.round(w/((h/100)*(h/100))*10)/10;
    bmiCat=bmi<18.5?'Underweight':bmi<23?'Healthy':bmi<25?'Overweight':'Obese';
    if(bmi>=23&&bmi<25){[3,15,18].forEach(s=>triggered.add(s));scoreTags.push('Fat Metabolism');}
    else if(bmi>=25){triggered.add(3);scoreTags.push('Fat Metabolism');}
    else if(bmi>=18.5&&bmi<23){triggered.add(15);triggered.add(18);}
  }

  // Ensure minimum 6 strains
  let strainList=Array.from(triggered);
  if(strainList.length<6){
    DEFAULT_STRAINS.forEach(d=>{if(!triggered.has(d))strainList.push(d);});
  }
  strainList=Array.from(new Set(strainList)).slice(0,20);

  // Score = 1 - (unique triggered categories / total categories)
  const uniqueTags=Array.from(new Set(scoreTags.filter(Boolean)));
  const score=Math.max(0,Math.min(100,Math.round((1-(uniqueTags.length/SCORED_CATS.length))*100)));

  return {
    strains:strainList,
    score,
    bmi,
    bmiCat,
    tags:uniqueTags,
    profile:{
      name:QZ.answers.name||'',
      phone:QZ.answers.phone||'',
      email:QZ.answers.email||'',
      age:QZ.answers.age||'',
      gender:QZ.answers.gender!==undefined?['Male','Female','Other'][QZ.answers.gender]:'',
      city:QZ.answers.city||''
    },
    answers:QZ.answers,
    multiSel:QZ.multiSel,
    botherSel:QZ.botherSel,
    completedAt:Date.now()
  };
}

// ── LEAD CAPTURE (placeholder) ──
function qzLeadCapture(){
  // Called after contact screen — sends name/phone/email + UTM
  const a=QZ.answers;
  const utm=(()=>{
    const p=new URLSearchParams(window.location.search);
    return {source:p.get('utm_source')||'',medium:p.get('utm_medium')||'',
      campaign:p.get('utm_campaign')||'',content:p.get('utm_content')||'',
      term:p.get('utm_term')||'',referrer:document.referrer,
      user_agent:navigator.userAgent.substr(0,200)};
  })();
  const sid=sessionStorage.getItem('sovax_session_id')||'sx_'+Date.now().toString(36);
  sessionStorage.setItem('sovax_session_id',sid);

  const payload={
    event:'profiling_completed',session_id:sid,
    name:a.name||'',phone:a.phone||'',email:a.email||'',
    src:'sovax_assessment',utm
  };
  console.log('[SovaX] Lead Capture (Contact):', payload);
  fetch('https://script.google.com/macros/s/AKfycbyHOvEvtNdg9z9LKRJCr9IaEVAzSWqIz_r5uzRXCB2C9P66UyJSdtFF0jU3GU-lOXA/exec',{method:'POST',mode:'no-cors',body:JSON.stringify(payload)}).catch(()=>{});
  trackEvent('lead_captured',{stage:'profiling',name:payload.name,phone:payload.phone});
  try{fbq('track','Lead',{value:0,currency:'INR',content_name:'Profiling Completed'});}catch(e){}
}

function qzProfilingComplete(){
  // Called after city Q (last profiling Q) — enriches with age/weight/height/gender/city
  const a=QZ.answers;
  const sid=sessionStorage.getItem('sovax_session_id')||'';
  const payload={
    event:'profiling_enriched',session_id:sid,
    phone:a.phone||'',email:a.email||'',name:a.name||'',
    age:a.age||'',
    gender:a.gender!==undefined?['Male','Female','Other'][a.gender]:'',
    weight:a.weight||'',height:a.height||'',city:a.city||''
  };
  console.log('[SovaX] Profiling Enriched:', payload);
  fetch('https://script.google.com/macros/s/AKfycbyHOvEvtNdg9z9LKRJCr9IaEVAzSWqIz_r5uzRXCB2C9P66UyJSdtFF0jU3GU-lOXA/exec',{method:'POST',mode:'no-cors',body:JSON.stringify(payload)}).catch(()=>{});
}

function qzLeadEnrich1(r){
  const sid=sessionStorage.getItem('sovax_session_id')||'sx_'+Date.now().toString(36);
  const strainList=r.strains.map(i=>STRAINS[i]).join(', ');

  const payload={
    event:'assessment_completed',
    session_id:sid,
    // Lead identity
    phone:r.profile?.phone||'',email:r.profile?.email||'',name:r.profile?.name||'',
    age:QZ.answers.age||'',
    gender:QZ.answers.gender!==undefined?['Male','Female','Other'][QZ.answers.gender]:'',
    weight:QZ.answers.weight||'',height:QZ.answers.height||'',
    city:QZ.answers.city||'',
    // Computed results
    gut_score:r.score,bmi:r.bmi,bmi_category:r.bmiCat,
    triggered_tags:(r.tags||[]).join(', '),
    strain_count:r.strains.length,
    strain_list:strainList,
    // Full Q&A dump for Responses tab
    answers:QZ.answers,
    multiSel:QZ.multiSel,
    botherSel:QZ.botherSel
  };

  // Build self-contained Base64 URLs (no session/phone params needed)
  const _b64payload = buildB64Payload(r);
  const _retargetUrl = encodeB64Url('https://x.sova.health/pages/assessment', _b64payload);
  const _reviewUrl   = encodeB64Url('https://x.sova.health/pages/formula-review', _b64payload);
  payload.retarget_url = _retargetUrl;
  payload.internal_url = _reviewUrl;
  console.log('[SovaX] Assessment Complete — sending to GAS:', payload);
  console.log('[SovaX] Retarget URL:', _retargetUrl);
  console.log('[SovaX] Review URL:', _reviewUrl);
  fetch('https://script.google.com/macros/s/AKfycbyHOvEvtNdg9z9LKRJCr9IaEVAzSWqIz_r5uzRXCB2C9P66UyJSdtFF0jU3GU-lOXA/exec',{
    method:'POST',
    mode:'no-cors',
    body:JSON.stringify(payload)
  }).catch(e=>console.error('[SovaX] GAS fetch failed:',e));

  trackEvent('assessment_completed',{gut_score:r.score,bmi:r.bmi,strain_count:r.strains.length,tags:(r.tags||[]).join(',')});
  try{fbq('track','CompleteRegistration',{value:5997,currency:'INR',content_name:'Assessment Completed',status:'completed'});}catch(e){}
}

// ── BUILD RESULT PAGE ──


// ── BASE64 URL ENCODING ──────────────────────────────────────────────
// Encodes result data into a self-contained Base64 URL fragment.
// No session/phone params needed — all data is in the URL itself.
function buildB64Payload(r){
  return {
    n:  r.profile?.name    || '',
    p:  r.profile?.phone   || '',
    e:  r.profile?.email   || '',
    a:  r.profile?.age     || '',
    g:  r.profile?.gender  || '',
    c:  r.profile?.city    || '',
    s:  r.score,
    b:  r.bmi,
    bc: r.bmiCat,
    st: r.strains,          // array of strain indices — compact
    t:  r.tags || [],
    sid: sessionStorage.getItem('sovax_session_id') || '',
    ts: Date.now()
  };
}

function encodeB64Url(baseUrl, payload){
  try {
    const json    = JSON.stringify(payload);
    // btoa with Unicode support
    const encoded = btoa(unescape(encodeURIComponent(json)));
    return baseUrl + '#b64=' + encoded;
  } catch(e) {
    // Fallback: no encoding
    return baseUrl;
  }
}

function decodeB64FromHash(hash){
  try {
    const m = (hash || window.location.hash).match(/[#&]b64=([^&]*)/);
    if(!m) return null;
    return JSON.parse(decodeURIComponent(escape(atob(m[1]))));
  } catch(e) { return null; }
}

// Expand compact payload back into a full result object
function expandB64Payload(d){
  if(!d) return null;
  return {
    strains:  d.st || [],
    score:    d.s  || 0,
    bmi:      d.b  || 0,
    bmiCat:   d.bc || '',
    tags:     d.t  || [],
    profile:  { name:d.n||'', phone:d.p||'', email:d.e||'', age:d.a||'', gender:d.g||'', city:d.c||'' },
    completedAt: d.ts || Date.now()
  };
}

// ── STRAIN TAG LOOKUP ──
function getStrainTag(si,tags){
  const map={
    0:'Immunity · Metabolic Health · Food Sensitivities',
    1:'Immunity · Metabolic Health · Food Sensitivities',
    2:'Immunity · Inner Beauty',
    3:'Fat Metabolism · Constipation',
    4:'Constipation · Fat Metabolism · Post-Antibiotic',
    5:'Post-Antibiotic · Diarrhea · Sleep',
    6:'Constipation · Fermented Foods · Sleep',
    7:'Bloating & Gas · Fermented Foods',
    8:'Constipation · Metabolic Health · Post-Antibiotic',
    9:'Gut Pain · Stress & Anxiety · Post-Antibiotic',
    10:'Acid Reflux · Bloating · Diarrhea · Gut Pain',
    11:'Acid Reflux · Stress & Anxiety · Sleep · Brain Fog',
    12:'Stress & Anxiety · Gut Brain Axis',
    13:'Post-Antibiotic Recovery · Immunity',
    14:'Acid Reflux / Acidity',
    15:'Fat Metabolism · Metabolic Health',
    16:'Bloating & Gas · Constipation',
    17:'Fermented Foods · Fat Metabolism',
    18:'Gut Brain Axis · Fat Metabolism · Constipation',
    19:'Diarrhea · Bloating & Gas'
  };
  return map[si]||'General gut health';
}

function showResultsFromData(r){
  document.body.style.overflow='';
  document.getElementById('res-ov').style.display='block';
  window.qzCurrentResult=r;

  const name=r.profile?.name||'there';
  const firstName=name.split(' ')[0];
  const tags=r.tags||[];
  const digestiveTags=tags.filter(t=>['Constipation','Diarrhea','Diarrhea/ Loose motions','Bloating & Gas','Acid Reflux/Acidity','Constipation & Diarrhea'].includes(t));
  const otherTags=tags.filter(t=>!digestiveTags.includes(t));
  const formulaId='SX-'+Math.random().toString(36).substr(2,4).toUpperCase()+'-'+Date.now().toString(36).toUpperCase().substr(-4);
  const scoreColor=r.score>=75?'#0EAD85':r.score>=50?'#F0B429':'#E05A7A';

  // Digestive symptoms list for callout
  const _dedupedDigestive=(function(){
    const hasBoth=digestiveTags.includes('Constipation & Diarrhea');
    const hasConst=digestiveTags.includes('Constipation');
    const hasDiarr=digestiveTags.includes('Diarrhea')||digestiveTags.includes('Diarrhea/ Loose motions');
    return digestiveTags.filter(t=>{
      if(t==='Constipation & Diarrhea'&&hasConst&&hasDiarr)return false;
      return true;
    }).map(t=>t.replace('Diarrhea/ Loose motions','Diarrhea'));
  })();
  const digestiveStr=_dedupedDigestive.length?_dedupedDigestive.join(', '):'Digestive issues';
  const otherStr=otherTags.length?otherTags.join(', '):'overall gut health';

  // Pre-computed HTML fragments (avoid nested template literals)
  const _strainRows=r.strains.map((si,i)=>'<tr><td style="white-space:nowrap;width:32px"><span class="strain-num">'+String(i+1).padStart(2,'0')+'</span></td><td style="font-weight:600">'+STRAINS[si]+'</td><td style="font-size:11px;color:var(--t2)">'+getStrainTag(si,tags)+'</td></tr>').join('');
  const _tagChips=tags.map(t=>'<span class="tag-chip neg">'+t+'</span>').join('')||'<span class="tag-chip">General Gut Health</span>';
  const _tagChips2=tags.map(t=>'<span class="tag-chip neg">'+t+'</span>').join('')||'<span class="tag-chip">Healthy baseline</span>';
  const html=`
  <!-- HERO -->
  <div class="res-hero">
    <div class="res-hero-bg"></div>
    <div class="res-hero-content">
      <div class="res-badge">Your Formula Is Ready</div>
      <div class="res-formula-id">Formula ID: ${formulaId}</div>
      <div class="res-name">Hi ${firstName}, your personalized gut supplement formula is ready.</div>
      <div class="res-subtitle">Formulated specifically for your gut profile · ${r.strains.length} probiotic strains selected · MCT Oil Base</div>
    </div>
    <div style="position:relative;z-index:2;padding:0 24px;text-align:center">
      <div class="res-stats" style="width:100%;max-width:100%">
        <div class="res-stat">
          <div class="res-stat-n">${r.score}<span style="font-size:13px">/100</span></div>
          <div class="res-stat-l">Gut Health Score</div>
        </div>
        <div class="res-stat">
          <div class="res-stat-n">${r.bmi||'—'}</div>
          <div class="res-stat-l">BMI · ${r.bmiCat||''}</div>
        </div>
        <div class="res-stat">
          <div class="res-stat-n">${r.strains.length}</div>
          <div class="res-stat-l">Probiotic Strains</div>
        </div>
        <div class="res-stat">
          <div class="res-stat-n">${tags.length}</div>
          <div class="res-stat-l">Areas Addressed</div>
        </div>
      </div>
    </div>
  </div>

  <!-- TABS -->
  <div class="res-tabs-bar">
    <div class="res-tabs-inner">
      <div class="res-tab on" onclick="resTab(0,this)">Your Formula</div>
      <div class="res-tab" onclick="resTab(1,this)">What to Expect</div>
      <div class="res-tab" onclick="resTab(2,this)">Gut Health Report</div>
      <div class="res-tab" onclick="resTab(3,this)">Expert Review</div>
    </div>
  </div>

  <!-- PANEL 0: YOUR FORMULA -->
  <div class="res-panel on" id="rp-0">
    <div class="res-inner">
      <div class="res-formula-hero">
        <!-- Product image + callouts -->
        <div>
          <div class="res-prod-img" style="position:relative">
            <img src="https://cdn.shopify.com/s/files/1/0628/8162/8294/files/sx1.png?v=1767315523" alt="SovaX personalized formula" loading="lazy">
            <!-- Mobile overlay callouts -->
            <div style="position:absolute;bottom:0;left:0;right:0;padding:12px;display:flex;gap:8px;background:linear-gradient(to top,rgba(4,8,6,.85),transparent)" class="res-img-mob-callouts">
              <div style="flex:1;background:rgba(255,255,255,.12);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.2);border-radius:8px;padding:8px 10px;text-align:center">
                <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:rgba(255,255,255,.6);margin-bottom:2px">Recommended</div>
                <div style="font-family:'Sora',sans-serif;font-size:13px;font-weight:700;color:#fff">90 Days</div>
              </div>
              <div style="flex:1;background:rgba(255,255,255,.12);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.2);border-radius:8px;padding:8px 10px;text-align:center">
                <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:rgba(255,255,255,.6);margin-bottom:2px">Strength</div>
                <div style="font-family:'Sora',sans-serif;font-size:13px;font-weight:700;color:#fff">${r.strains.length} Bn CFUs</div>
              </div>
            </div>
          </div>

        </div>
        <!-- Callout + CTA -->
        <div class="res-callout">
          <div class="res-callout-badge">Personalized Formula Ready</div>
          <div class="res-callout-h">${firstName}'s Personalized Gut Supplement</div>
          <div style="margin-bottom:16px;display:flex;flex-direction:column;gap:8px">
            ${digestiveTags.length?'<div class="res-callout-benefit"><strong>7-day relief:</strong> '+digestiveStr+'</div>':''}
            <div class="res-callout-benefit"><strong>90-day fix:</strong> Root-cause microbiome restoration</div>
            ${otherTags.length?'<div class="res-callout-benefit"><strong>Also addresses:</strong> '+otherStr+'</div>':''}
            <div class="res-callout-benefit">${r.strains.length} probiotic strains · MCT Oil base · NABL lab · Free delivery</div>
          </div>
          <div class="res-price-row">
            <!-- Pricing table -->
            <div style="background:rgba(255,255,255,.06);border-radius:12px;overflow:hidden;margin-bottom:10px;border:1px solid rgba(255,255,255,.1)">
              <div style="display:grid;grid-template-columns:1fr auto;gap:0">
                <div style="padding:9px 14px;font-size:11px;color:rgba(255,255,255,.5);border-bottom:1px solid rgba(255,255,255,.08);text-transform:uppercase;letter-spacing:.08em">Base price / month</div>
                <div style="padding:9px 14px;font-size:11px;color:rgba(255,255,255,.5);text-align:center;border-bottom:1px solid rgba(255,255,255,.08);border-left:1px solid rgba(255,255,255,.08);text-transform:uppercase;letter-spacing:.08em">Duration</div>
              </div>
              <div style="display:grid;grid-template-columns:1fr auto;gap:0;align-items:center">
                <div style="padding:14px">
                  <div style="font-family:'Sora',sans-serif;font-size:24px;font-weight:700;color:var(--teal)">₹1,999<span style="font-size:12px;font-weight:400;color:rgba(255,255,255,.45)">/month</span></div>
                  <div style="font-size:10px;color:rgba(255,255,255,.4);margin-top:2px">No-cost EMI available</div>
                </div>
                <div style="padding:14px;text-align:center;border-left:1px solid rgba(255,255,255,.08)">
                  <div style="font-family:'Sora',sans-serif;font-size:22px;font-weight:700;color:#fff">3</div>
                  <div style="font-size:11px;color:rgba(255,255,255,.45)">months</div>
                </div>
              </div>
              <div style="padding:12px 14px;background:rgba(255,255,255,.04);border-top:1px solid rgba(255,255,255,.08);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:6px">
                <div style="font-size:11px;color:rgba(255,255,255,.5)">Total (90-day supply)</div>
                <div style="display:flex;align-items:center;gap:8px;flex-shrink:0;white-space:nowrap">
                  <div style="font-size:11px;text-decoration:line-through;color:rgba(255,255,255,.3);white-space:nowrap">₹8,999</div>
                  <div style="font-family:'Sora',sans-serif;font-size:20px;font-weight:700;color:#fff;white-space:nowrap">₹5,997</div>
                  <div style="font-size:11px;font-weight:700;color:var(--teal);background:rgba(14,173,133,.15);padding:2px 8px;border-radius:100px;white-space:nowrap">Save ₹3,002</div>
                </div>
              </div>
            </div>
            <button class="res-buy-btn" onclick="goToCheckout()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>
              Order My Gut Fix
            </button>
            <div class="res-pay-row">
              <span class="res-pay-pill">UPI</span><span class="res-pay-pill">Cards</span><span class="res-pay-pill">No-cost EMI</span><span class="res-pay-pill">Subscription</span>
            </div>
            <div style="font-size:11px;color:rgba(255,255,255,.35);text-align:center;margin-top:10px">Expert consultation included · Delivery in 10 days · Free shipping</div>
          </div>
        </div>
      </div>

      <!-- INGREDIENTS SECTION -->
      <div id="res-ingr-block">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;cursor:pointer" onclick="document.getElementById('res-ingr-details').classList.toggle('open-all')">
          <div>
            <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:6px;font-family:'DM Sans',sans-serif">Ingredient List</div>
            <div style="font-family:'Sora',sans-serif;font-size:20px;font-weight:700;color:var(--text);letter-spacing:-.4px">View Full Ingredient Breakdown</div>
          </div>
          <div style="font-size:13px;font-weight:600;color:var(--teal);display:flex;align-items:center;gap:6px">
            See formula <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
        <div class="ingr-sections" id="res-ingr-details" style="display:none">
          <!-- Probiotic Blend -->
          <div class="ingr-sec open">
            <div class="ingr-sec-head" onclick="this.closest('.ingr-sec').classList.toggle('open')">
              <div><span class="ingr-sec-title">Proprietary Probiotic Blend</span><span class="ingr-sec-badge">${r.strains.length} Strains</span></div>
              <svg class="ingr-sec-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
            <div class="ingr-sec-body">
              <div class="ingr-commentary">Based on ${firstName}'s gut health assessment, these ${r.strains.length} probiotic strains were identified as deficient. Each strain targets specific pathways linked to the symptoms reported: ${digestiveStr}${otherTags.length?' and '+otherStr:''}.</div>
              <table class="strain-table" style="margin-top:14px">
                <thead><tr><th>#</th><th>Probiotic Strain</th><th>Role</th></tr></thead>
                <tbody>${_strainRows}</tbody>
              </table>
            </div>
          </div>

            <div class="ingr-sec-body">
              <table class="ni-table" style="margin-top:6px">
                <thead><tr><th>Ingredient</th><th>Amount</th><th>Activity</th><th>RDA %</th><th>Role</th></tr></thead>
                <tbody>
                  <tr><td>Amylase</td><td>—</td><td>300 DU</td><td class="ni-rda">—</td><td style="font-size:11px;color:var(--t2)">Starch breakdown · prevents fermentation gas</td></tr>
                  <tr><td>Lipase</td><td>—</td><td>100 FIP</td><td class="ni-rda">—</td><td style="font-size:11px;color:var(--t2)">Fat digestion · improves nutrient absorption</td></tr>
                  </tbody>
              </table>
            </div>
          </div>
          <!-- NI Table -->
          <div class="ingr-sec">
            <div class="ingr-sec-head" onclick="this.closest('.ingr-sec').classList.toggle('open')">
              <div><span class="ingr-sec-title">Nutritional Information</span><span class="ingr-sec-badge">Per 1.5g Serving</span></div>
              <svg class="ingr-sec-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
            <div class="ingr-sec-body">
              <table class="ni-table" style="margin-top:6px">
                <thead><tr><th>Nutrient</th><th>Amount per serving</th><th>% RDA*</th></tr></thead>
                <tbody>
                  <tr><td>Energy</td><td>5 kcal</td><td class="ni-rda">—</td></tr>
                  <tr><td>Total Carbohydrate</td><td>0.8 g</td><td class="ni-rda">—</td></tr>
                  <tr><td>Total Fat</td><td>0.3 g</td><td class="ni-rda">—</td></tr>
                  <tr><td>Protein</td><td>0.2 g</td><td class="ni-rda">—</td></tr>
                  <tr><td>MCT Oil Powder</td><td>200 mg</td><td class="ni-rda">—</td></tr>
                  <tr><td>Probiotic Blend (Total CFU)</td><td>Minimum 10 Billion CFU</td><td class="ni-rda">†</td></tr>
                  </tbody>
              </table>
              <div style="font-size:10px;color:var(--t3);margin-top:10px;line-height:1.5">*RDA = Recommended Daily Allowance as per ICMR (Indian Council of Medical Research). †Daily value not established. Serving size: 1 sachet (1.5 g). Servings per pack: 90 (90-day supply). Allergen info: Contains no common allergens. Non-GMO. No added sugar. No preservatives. FSSAI Approved. NABL Certified facility.</div>
            </div>
          </div>
        </div>
        <button onclick="const d=document.getElementById('res-ingr-details');d.style.display=d.style.display==='none'?'flex':'none';this.textContent=d.style.display==='none'?'Show Ingredient List ↓':'Hide Ingredient List ↑'" style="margin-top:8px;padding:10px 20px;border:1.5px solid var(--bdr2);border-radius:100px;background:transparent;font-size:13px;font-weight:600;color:var(--text);cursor:pointer;display:flex;align-items:center;gap:6px">
          Show Ingredient List ↓
        </button>
      </div>

      <!-- FINAL STICKY CTA -->
      <div style="background:var(--text);border-radius:20px;padding:28px;text-align:center;margin-top:40px">
        <div style="font-family:'Sora',sans-serif;font-size:20px;font-weight:700;color:#fff;margin-bottom:6px">Ready to fix your gut for good?</div>
        <div style="font-size:13px;color:rgba(255,255,255,.6);margin-bottom:20px">Your formula is ready. ${r.strains.length} targeted strains. 90-day supply. Delivered in 10 days.</div>
        <button class="res-buy-btn" onclick="goToCheckout()" style="max-width:400px;margin:0 auto">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>
          Order My Gut Fix — ₹5,997
        </button>
        <div style="font-size:11px;color:rgba(255,255,255,.35);margin-top:10px">Free delivery · Expert consultation · NABL certified · 10-day delivery</div>
      </div>
    </div>
  </div>

  <!-- PANEL 1: WHAT TO EXPECT -->
  <div class="res-panel" id="rp-1">
    <div class="res-inner">
      <div style="font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:8px">Your 90-Day Journey</div>
      <div style="font-family:'Sora',sans-serif;font-size:clamp(20px,3vw,26px);font-weight:700;letter-spacing:-.5px;color:var(--text);margin-bottom:8px">What to expect — week by week</div>
      <div style="font-family:'DM Sans',sans-serif;font-size:14px;color:var(--t2);line-height:1.6;margin-bottom:24px">Personalized to your gut profile. Probiotic strains begin colonizing from your first dose — visible relief by Week 1, lasting root-cause fix by Day 90.</div>
      <canvas id="res-chart" style="max-height:280px;margin-bottom:28px"></canvas>
      <div class="phase-cards" style="width:100%;box-sizing:border-box">
        <div class="phase-card"><div class="phase-card-wk">Week 1</div><div class="phase-card-h">Strains Colonize</div><div class="phase-card-d">Probiotic strains begin establishing. Early symptom improvement visible from week 1.</div></div>
        <div class="phase-card"><div class="phase-card-wk">Week 2–4</div><div class="phase-card-h">Strains Colonize</div><div class="phase-card-d">Probiotic strains establish. Regularity and gas noticeably improve.</div></div>
        <div class="phase-card"><div class="phase-card-wk">Week 5–8</div><div class="phase-card-h">Gut Restores</div><div class="phase-card-d">Gut lining repairs. Energy, skin, and immunity begin improving.</div></div>
        <div class="phase-card"><div class="phase-card-wk">Week 9–12</div><div class="phase-card-h">Full Balance</div><div class="phase-card-d">Sustained low-symptom state. Long-term microbiome fix achieved.</div></div>
      </div>
      <div style="margin-top:28px;padding:20px;background:var(--bg2);border:1px solid var(--bdr);border-radius:var(--r2)">
        <div style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--teal);margin-bottom:6px">Your key areas of improvement</div>
        <div class="tag-chips">${_tagChips}</div>
      </div>
      <div style="text-align:center;margin-top:28px">
        <button class="res-buy-btn" onclick="goToCheckout()" style="max-width:400px;margin:0 auto">Order My Gut Fix — ₹5,997</button>
      </div>
    </div>
  </div>

  <!-- PANEL 2: GUT HEALTH REPORT -->
  <div class="res-panel" id="rp-2">
    <div class="res-inner">
      <div style="font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:8px">Your Personal Report</div>
      <div style="font-family:'Sora',sans-serif;font-size:clamp(20px,3vw,26px);font-weight:700;letter-spacing:-.5px;color:var(--text);margin-bottom:8px">Gut Health Score: ${r.score} / 100</div>
      <div style="font-family:'DM Sans',sans-serif;font-size:14px;color:var(--t2);line-height:1.6;margin-bottom:20px">Your score reflects the number of gut health markers currently out of balance. ${r.score>=75?'Your gut is performing reasonably well — this formula addresses the specific gaps.':r.score>=50?'Moderate imbalance detected — clear areas driving your symptoms.':'Significant imbalance detected — the right formula will make a measurable difference.'}</div>
      <div style="display:flex;align-items:center;gap:24px;flex-wrap:wrap;margin-bottom:28px">
        <div class="res-score-ring-wrap">
          <div class="res-score-ring">
            <svg viewBox="0 0 160 160">
              <circle cx="80" cy="80" r="64" stroke="#E5E7EB" stroke-width="12" fill="none"/>
              <circle cx="80" cy="80" r="64" stroke="${scoreColor}" stroke-width="12" fill="none"
                stroke-dasharray="${2*Math.PI*64}" stroke-dashoffset="${2*Math.PI*64*(1-r.score/100)}" stroke-linecap="round"/>
            </svg>
            <div class="res-score-num">
              <div class="res-score-val">${r.score}</div>
              <div class="res-score-label">/ 100</div>
            </div>
          </div>
        </div>
        <div style="flex:1;min-width:200px">
          <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--t2);margin-bottom:8px">Areas Out of Balance</div>
          <div class="tag-chips">${_tagChips2}</div>
        </div>
      </div>
      <div style="background:var(--bg2);border:1px solid var(--bdr);border-radius:var(--r);padding:20px;margin-bottom:20px">
        <div style="font-family:'Sora',sans-serif;font-size:14px;font-weight:700;margin-bottom:12px">What your score means</div>
        <div style="display:flex;gap:0;height:10px;border-radius:100px;overflow:hidden;margin-bottom:8px">
          <div style="flex:30;background:#E05A7A"></div><div style="flex:25;background:#F0B429"></div><div style="flex:25;background:#7BC67E"></div><div style="flex:20;background:#0EAD85"></div>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:10px;color:var(--t3);margin-bottom:16px"><span>0</span><span>30</span><span>55</span><span>80</span><span>100</span></div>
        <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px">
          <div style="text-align:center">
            <div style="width:12px;height:12px;border-radius:50%;background:#E05A7A;margin:0 auto 6px"></div>
            <div style="font-size:11px;font-weight:700;color:var(--text)">0–30 · Critical</div>
            <div style="font-size:10px;color:var(--t3);margin-top:3px;line-height:1.4">Severe microbiome disruption. Multiple areas affected. Targeted therapy needed urgently.</div>
          </div>
          <div style="text-align:center">
            <div style="width:12px;height:12px;border-radius:50%;background:#F0B429;margin:0 auto 6px"></div>
            <div style="font-size:11px;font-weight:700;color:var(--text)">31–55 · Moderate</div>
            <div style="font-size:10px;color:var(--t3);margin-top:3px;line-height:1.4">Clear imbalances driving symptoms. Consistent probiotic therapy produces strong results.</div>
          </div>
          <div style="text-align:center">
            <div style="width:12px;height:12px;border-radius:50%;background:#7BC67E;margin:0 auto 6px"></div>
            <div style="font-size:11px;font-weight:700;color:var(--text)">56–79 · Good</div>
            <div style="font-size:10px;color:var(--t3);margin-top:3px;line-height:1.4">Functioning gut with specific gaps. Formula targets these precisely for optimization.</div>
          </div>
          <div style="text-align:center">
            <div style="width:12px;height:12px;border-radius:50%;background:#0EAD85;margin:0 auto 6px"></div>
            <div style="font-size:11px;font-weight:700;color:var(--text)">80–100 · Optimal</div>
            <div style="font-size:10px;color:var(--t3);margin-top:3px;line-height:1.4">Healthy baseline. Formula maintains balance and prevents future disruption.</div>
          </div>
        </div>
        <div style="margin-top:16px;padding:14px;background:var(--bg3);border-radius:var(--r2);font-size:13px;color:var(--t2);line-height:1.55">
          ${r.score<=30?"<strong>Your score indicates significant gut disruption.</strong> This is common — and reversible. Patients with scores in this range typically see the most dramatic improvement with Sova X because there's the most room for positive change.":r.score<=55?"<strong>Moderate gut imbalance detected.</strong> This level correlates strongly with the symptoms you reported. Targeted probiotic therapy at this level typically produces visible symptom relief within 3–4 weeks.":r.score<=79?"<strong>Good gut health with specific gaps.</strong> Your gut is functioning reasonably well, but there are identifiable deficiencies driving your symptoms. The formula addresses these precisely.":"<strong>Excellent gut health baseline.</strong> Your formula is designed to maintain this balance and address the specific areas that could be further optimized."}
        </div>
      </div>
    </div>
  </div>

  <!-- PANEL 3: EXPERT REVIEW -->
  <div class="res-panel" id="rp-3">
    <div class="res-inner">
      <div style="font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:8px">Expert Review</div>
      <div style="font-family:'Sora',sans-serif;font-size:clamp(20px,3vw,26px);font-weight:700;letter-spacing:-.5px;color:var(--text);margin-bottom:8px">What our experts say about ${firstName}'s formula</div>
      <div style="font-family:'DM Sans',sans-serif;font-size:14px;color:var(--t2);line-height:1.6;margin-bottom:20px">Each expert reviewed your full symptom profile and lifestyle data.</div>
      <div class="expert-cards" id="res-expert-cards"></div>
      <div style="text-align:center;margin-top:28px">
        <button class="res-buy-btn" onclick="goToCheckout()" style="max-width:400px;margin:0 auto">Order My Gut Fix — ₹5,997</button>
      </div>
    </div>
  </div>
 
  <!-- COMMON: TESTIMONIALS + FAQS (outside tabs) -->
  <div class="res-inner" style="border-top:2px solid var(--bdr);padding-top:40px">

      <div style="margin-top:40px;padding-top:32px;border-top:1px solid var(--bdr)">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:8px;font-family:'DM Sans',sans-serif">Customer Stories</div>
        <div style="font-family:'Sora',sans-serif;font-size:clamp(20px,3vw,26px);font-weight:700;color:var(--text);margin-bottom:16px">50,000+ Happy Customers · Real Results</div>
        <div class="res-sec-h">Real results from real people</div>
        <div class="res-rev-grid" style="margin-top:16px">
          <div class="res-rev-card"><div class="res-rev-stars">★★★★★</div><div class="res-rev-text">"After 3 years of bloating every single day, it finally stopped by week 3. I genuinely didn't think any supplement could do this."</div><div class="res-rev-author">Priya M.</div><div class="res-rev-city">Bengaluru · Bloating & Gas</div></div>
          <div class="res-rev-card"><div class="res-rev-stars">★★★★★</div><div class="res-rev-text">"The Sova X team called me before my formula even shipped. No supplement company has ever done that. And then it actually worked."</div><div class="res-rev-author">Arjun S.</div><div class="res-rev-city">Mumbai · Constipation · IBS</div></div>
          <div class="res-rev-card"><div class="res-rev-stars">★★★★★</div><div class="res-rev-text">"I was skeptical about the price. But I've spent more on antacids in a year than this costs. And this actually fixed the problem."</div><div class="res-rev-author">Sneha T.</div><div class="res-rev-city">Hyderabad · Acid Reflux</div></div>
        </div>
      </div>


      <div style="margin-top:40px;padding-top:32px;border-top:1px solid var(--bdr)">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--teal);margin-bottom:8px;font-family:'DM Sans',sans-serif">FAQ</div>
        <div style="font-family:'Sora',sans-serif;font-size:clamp(20px,3vw,26px);font-weight:700;color:var(--text);margin-bottom:20px">Common questions about your formula</div>
        <div class="res-faq-item op">
          <button class="res-faq-btn" onclick="this.closest('.res-faq-item').classList.toggle('op')">When will I start feeling better? <span class="fq-ic">+</span></button>
          <div class="res-faq-ans">Probiotic strains begin colonizing from your first dose. Visible relief typically starts in Week 1 — reduced bloating, gas, and discomfort. Probiotic strains begin establishing from Week 2–3. Significant symptom relief typically occurs by Week 4–6. Full gut ecosystem restoration is measurable at 12 weeks.</div>
        </div>
        <div class="res-faq-item">
          <button class="res-faq-btn" onclick="this.closest('.res-faq-item').classList.toggle('op')">Why ${r.strains.length} specific strains and not a generic formula? <span class="fq-ic">+</span></button>
          <div class="res-faq-ans">Your ${r.strains.length} strains were selected because your assessment profile indicates a deficiency specifically in those bacterial species. Adding extra strains doesn't help — it wastes dosage and can even cause imbalance. Your formula contains exactly what your gut needs and nothing extra.</div>
        </div>
        <div class="res-faq-item">
          <button class="res-faq-btn" onclick="this.closest('.res-faq-item').classList.toggle('op')">What happens after I order? <span class="fq-ic">+</span></button>
          <div class="res-faq-ans">Your formula is compounded fresh after your order — it's never pre-made. This takes 5–7 days. An expert from the Sova X team calls you to schedule your consultation before delivery. You'll receive your sachet pack within 10 days.</div>
        </div>
        <div class="res-faq-item">
          <button class="res-faq-btn" onclick="this.closest('.res-faq-item').classList.toggle('op')">Is ₹5,999 worth it? <span class="fq-ic">+</span></button>
          <div class="res-faq-ans">Consider that most people with gut issues spend ₹500–2,000/month on antacids, digestive aids, and OTC supplements — for years. Sova X is a 90-day root-cause fix. After 90 days, most customers no longer need daily supplements. The math works out, and more importantly, it works.</div>
        </div>
      </div>


  </div> `;

  document.getElementById('res-content').innerHTML=html;

  // Render expert cards
  document.getElementById('res-expert-cards').innerHTML=generateExpertComments(firstName,r);

  // Render chart (deferred to panel 1 activation)
  window._resChartRendered=false;

  // Floating buy button
  const floatBuy=document.getElementById('res-float-buy');
  floatBuy.innerHTML=`<button class="res-buy-btn" onclick="goToCheckout()" style="max-width:600px;margin:0 auto;display:flex">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>
    Order My Gut Fix — ₹5,997 · Free Delivery
  </button>`;
  const resOv=document.getElementById('res-ov');
  resOv.addEventListener('scroll',()=>{floatBuy.classList.toggle('vis',resOv.scrollTop>400);},{passive:true});

  trackEvent('results_viewed',{gut_score:r.score,strain_count:r.strains.length});
  try{fbq('track','ViewContent',{content_name:'Assessment Results',value:5997,currency:'INR'});}catch(e){}
}

function resTab(idx,el){
  document.querySelectorAll('.res-tab').forEach((t,i)=>t.classList.toggle('on',i===idx));
  document.querySelectorAll('.res-panel').forEach((p,i)=>p.classList.toggle('on',i===idx));
  // Render chart lazily when expect tab opened
  if(idx===1&&!window._resChartRendered){
    const r=window.qzCurrentResult;
    if(r){renderResChart(r);window._resChartRendered=true;}
  }
  // Scroll to top of res-ov
  const ro=document.getElementById('res-ov');
  if(ro)ro.scrollTo({top:0,behavior:'smooth'});
}


function renderResChart(r){
  const el=document.getElementById('res-chart');
  if(!el)return;
  const tags=r.tags||[];
  
  // Symptom-specific colors
  const symColors={
    'Bloating & Gas':'#0EAD85','Constipation':'#E8873A','Diarrhea':'#7B68D4',
    'Constipation & Diarrhea':'#9B7FD4','Acid Reflux/Acidity':'#E05A7A',
    'Gut Brain Axis':'#F0B429','Stress & Anxiety':'#4BB38A','Sleep cycle':'#4BB38A',
    'Fat Metabolism':'#9B7FD4','Immunity':'#F0B429','Inner Beauty':'#E05A7A',
    'Metabolic Health':'#E8873A','Gut Barrier':'#E8873A','Food Sensitivities':'#7B68D4',
    'Post Antibiotic Recovery':'#F0B429','default':'#0EAD85'
  };
  
  // Decay curves by symptom type
  // Labels: Day 1, Wk 1, Wk 2, Wk 3, Wk 4, Wk 6, Wk 8, Wk 10, Wk 12
  const curves={
    fast:  [100,72,55,42,30,18,10,5,2],   // Bloating, Diarrhea — fast-responding strains
    medium:[100,88,75,62,50,35,22,12,5],   // Acidity, Constipation — slower
    slow:  [100,93,85,75,64,50,36,22,10],  // Metabolic, Immunity, etc
  };
  function getCurve(tag){
    if(['Bloating & Gas','Diarrhea','Diarrhea/ Loose motions'].includes(tag))return curves.fast;
    if(['Constipation','Acid Reflux/Acidity','Constipation & Diarrhea'].includes(tag))return curves.medium;
    return curves.slow;
  }
  
  // Pick up to 3 meaningful symptoms — dedup Constipation & Diarrhea
  let showTags=tags.filter(t=>symColors[t]);
  const hasConst=showTags.includes('Constipation');
  const hasDiarr=showTags.includes('Diarrhea')||showTags.includes('Diarrhea/ Loose motions');
  if(hasConst&&hasDiarr) showTags=showTags.filter(t=>t!=='Constipation & Diarrhea');
  showTags=showTags.slice(0,3);
  if(!showTags.length)showTags.push('Gut Health');
  
  const labels=['Day 1','Wk 1','Wk 2','Wk 3','Wk 4','Wk 6','Wk 8','Wk 10','Wk 12'];
  const datasets=showTags.map(tag=>{
    const col=symColors[tag]||symColors.default;
    return{
      label:tag,data:getCurve(tag),borderColor:col,backgroundColor:col+'18',
      fill:true,tension:.45,borderWidth:2.5,pointRadius:3.5,pointBackgroundColor:col
    };
  });
  
  new Chart(el,{
    type:'line',data:{labels,datasets},
    options:{
      responsive:true,maintainAspectRatio:true,
      plugins:{
        legend:{display:true,position:'top',labels:{font:{family:"'DM Sans',sans-serif",size:12},color:'#5A5A52',padding:16,boxWidth:12,usePointStyle:true}},
        tooltip:{mode:'index',intersect:false,backgroundColor:'rgba(6,10,8,.9)',titleColor:'#fff',bodyColor:'rgba(255,255,255,.7)',padding:10,cornerRadius:8,callbacks:{label:ctx=>`${ctx.dataset.label}: ${ctx.raw}% severity`}}
      },
      scales:{
        x:{grid:{color:'rgba(0,0,0,.04)'},ticks:{font:{size:11},color:'#888'}},
        y:{grid:{color:'rgba(0,0,0,.04)'},ticks:{font:{size:11},color:'#888',callback:v=>v+'%'},
          title:{display:true,text:'Symptom Severity',font:{size:11},color:'#888'},
          min:0,max:100}
      }
    }
  });
}

// ── EXPERT COMMENT GENERATOR ──
function generateExpertComments(name,r){
  const tags=r.tags;
  const hasDigestive=tags.some(t=>['Constipation','Diarrhea','Bloating & Gas','Acid Reflux/Acidity','Gut Barrier','Food Sensitivities','Constipation & Diarrhea'].includes(t));
  const hasMetabolic=tags.some(t=>['Fat Metabolism','Metabolic Health'].includes(t));
  const hasMental=tags.some(t=>['Gut Brain Axis','Stress & Anxiety','Sleep cycle'].includes(t));
  const hasImmunity=tags.includes('Immunity')||tags.includes('Post Antibiotic Recovery');
  const score=r.score;

  const maxComment=hasDigestive
    ?`${name}'s assessment shows clear microbiome imbalances driving the digestive symptoms they're experiencing. The specific probiotic strains we've selected target the root cause — not just symptom suppression. With ${r.strains.length} strains at precise dosages, this formula addresses both the immediate discomfort and the long-term bacterial population deficits. I expect measurable relief within the first 7 days as probiotic strains begin colonizing, with lasting improvement by week 8.`
    :hasMetabolic
    ?`The gut-metabolism connection in ${name}'s profile is significant. Imbalanced gut flora directly affects insulin sensitivity, fat storage hormones, and appetite regulation. The strains we've selected — particularly for metabolic health — have peer-reviewed evidence for improving these pathways. This isn't just a probiotic; it's a metabolic recalibration.`
    :`Based on ${name}'s overall assessment, this formula is designed for comprehensive gut ecosystem restoration. At ${score}%, there's meaningful room for improvement — and the right combination of strains at therapeutic dosages makes a measurable difference. Consistency for 90 days is the key.`;

  const gargiComment=hasMetabolic||hasMental
    ?`Looking at ${name}'s lifestyle and dietary patterns, I'd combine this formula with a few dietary adjustments: increase prebiotic-rich foods (ragi, oats, bananas) to fuel these strains. The formula does the clinical work, but nutrition creates the environment where these bacteria thrive. I've seen clients with similar profiles achieve 60–80% symptom reduction within 6 weeks when they combine formula compliance with these dietary shifts.`
    :hasDigestive
    ?`${name}'s dietary patterns suggest specific nutrient gaps that are amplifying their gut symptoms. The targeted probiotic strains in this formula will improve nutrient absorption — this means better energy and reduced post-meal discomfort. I'd recommend taking the sachet with breakfast to maximize probiotic colonization during the body's peak digestive activity.`
    :`${name}'s profile suggests a gut ecosystem that's been gradually depleted — likely over months or years. The good news is this is reversible. I recommend being consistent with the formula for at least 12 weeks. The first 3 weeks feel like slow progress, but weeks 4–12 is where the compounding effect becomes noticeable.`;

  const simranComment=r.strains.length>0
    ?`I want to walk ${name} through two specific strains in their formula. ${STRAINS[r.strains[0]]} was selected because ${STRAIN_BENEFIT[r.strains[0]].toLowerCase()} And ${STRAINS[r.strains[1]||r.strains[0]]} addresses ${STRAIN_BENEFIT[r.strains[1]||r.strains[0]].toLowerCase()} Your targeted probiotic strains establish progressively, creating visible relief from Week 1 and lasting structural improvement over 90 days.`
    :`The formula reflects ${name}'s gut health data precisely. Each strain was selected from a library of 30+ species — only the ones confirmed deficient in your profile make it in. This is the key differentiator: no unnecessary bacteria, no risk of over-supplementation, just exactly what your gut needs.`;

  const drSubComment=score>=80
    ?`From a clinical perspective, ${name}'s gut health score of ${score}% indicates a generally functional microbiome with a few specific deficiencies. The formula targets these precisely. I expect ${name} to notice improved regularity within 7 days, reduced inflammation markers by week 4, and measurable improvement in energy and overall wellbeing by week 8. Full microbiome restoration is achievable within the 90-day protocol.`
    :score>=60
    ?`${name}'s assessment reveals a moderately imbalanced microbiome — common in adults with the lifestyle patterns identified. The gut health score of ${score}% tells us that roughly ${100-score}% of the measured markers need attention. This formula directly addresses those markers. Clinically, patients with this profile achieve the most dramatic results with Sova X — because there's meaningful room for improvement and the right strains make a measurable difference quickly.`
    :`${name}'s gut health score of ${score}% indicates a significantly disrupted microbiome. This level of imbalance typically correlates with the symptom severity reported — it's not random. The good news: disrupted microbiomes respond well to targeted probiotic therapy. I've seen patients with similar scores achieve near-complete symptom resolution within 90 days on correctly formulated protocols. The key is consistency and the right strains — both of which this formula provides.`;

  return [
    {name:'Max Kushnir',role:'Chief Science Officer & Co-Founder',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/156.jpg?v=1776677665',comment:maxComment},
    {name:'Gargi Sareen',role:'Head, Gut Health Expert',img:'https://cdn.shopify.com/s/files/1/0628/8162/8294/files/155.jpg?v=1776677665',comment:gargiComment},
    {name:'Simran Yadav',role:'Clinical Nutritionist',img:'https://cdn.shopify.com/s/files/1/0687/4523/2705/files/52.png?v=1768114386',comment:simranComment},
    {name:'Dr. Subhanshu Gupta',role:'Gastroenterologist · MD',img:'https://brand.sova.health/cdn/shop/files/DR_shubhanshu.jpg?v=1768569957',comment:drSubComment}
  ].map(e=>`
    <div class="ec2">
      <div class="ec2-head">
        <div class="ec2-photo"><img src="${e.img}" alt="${e.name}" loading="lazy" onerror="this.parentElement.style.background='var(--tl)';this.style.display='none'"></div>
        <div><div class="ec2-name">${e.name}</div><div class="ec2-role">${e.role}</div></div>
      </div>
      <div class="ec2-quote">"${e.comment}"</div>
    </div>`).join('');
}

// ── CHECKOUT ──
function goToCheckout(){
  const r=window.qzCurrentResult||JSON.parse(sessionStorage.getItem(SS_RES)||'{}');
  if(!r.strains)return;
  const strainList=r.strains.map(i=>STRAINS[i]).join(', ');
  const strainListShort=r.strains.map(i=>STRAINS[i]).join('|');

  // Full formulation note for Shopify order
  const lines=[
    'SOVA X PERSONALIZED FORMULA',
    '─────────────────────────────',
    'Customer: '+(r.profile?.name||'')+'  |  Phone: '+(r.profile?.phone||''),
    'Email: '+(r.profile?.email||'')+'  |  City: '+(r.profile?.city||''),
    'Age: '+(r.profile?.age||'')+'  |  Gender: '+(r.profile?.gender||''),
    'BMI: '+(r.bmi||'')+'  ('+(r.bmiCat||'')+')',
    '─────────────────────────────',
    'GUT HEALTH SCORE: '+r.score+' / 100',
    'Issues Identified: '+((r.tags||[]).join(', ')||'General'),
    '─────────────────────────────',
    'PROBIOTIC BLEND ('+r.strains.length+' Strains):',
    ...( r.strains.map((si,i)=>(i+1)+'. '+STRAINS[si]) ),
    '─────────────────────────────',
    'Formula ID: SX-'+Date.now().toString(36).toUpperCase().substr(-6)
  ];
  const fullNote=lines.join('\n');

  // GAS webhook — checkout event
  fetch('https://script.google.com/macros/s/AKfycbyHOvEvtNdg9z9LKRJCr9IaEVAzSWqIz_r5uzRXCB2C9P66UyJSdtFF0jU3GU-lOXA/exec',{
    method:'POST',
    mode:'no-cors',
    body:JSON.stringify({
      event:'checkout_initiated',
      session_id:sessionStorage.getItem('sovax_session_id')||'',
      phone:r.profile?.phone||'',
      email:r.profile?.email||'',
      name:r.profile?.name||'',
      gut_score:r.score,
      bmi:r.bmi,
      strain_count:r.strains.length,
      strain_list:strainList,
      triggered_tags:(r.tags||[]).join(', ')
    })
  }).catch(()=>{});

  trackEvent('checkout_initiated',{gut_score:r.score,strain_count:r.strains.length,value:5997,currency:'INR'});
  try{fbq('track','Purchase',{value:5997,currency:'INR',content_name:'SovaX Formula',content_ids:[strainListShort],num_items:1});}catch(e){}

  // Shopify: inject via cart/add.js POST then redirect (note is supported in checkout)
  // Use attributes[] for structured data + note for human-readable summary
  const cartParams=new URLSearchParams();
  cartParams.set('id','43980531826822');
  cartParams.set('quantity','1');
  cartParams.set('properties[Customer_Name]',r.profile?.name||'');
  cartParams.set('properties[Phone]',r.profile?.phone||'');
  cartParams.set('properties[Gut_Score]',String(r.score));
  cartParams.set('properties[Strain_Count]',String(r.strains.length));
  cartParams.set('properties[Probiotic_Strains]',strainList);

  // Try Shopify AJAX cart API (works on x.sova.health same-origin)
  fetch('https://x.sova.health/cart/add.js',{
    method:'POST',credentials:'include',
    headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},
    body:cartParams.toString()
  }).then(res=>{
    // Redirect to checkout with note
    const checkoutUrl='https://x.sova.health/checkout'
      +'?note='+encodeURIComponent(fullNote)
      +'&checkout[attributes][Formula_Strains]='+encodeURIComponent(strainListShort)
      +'&checkout[attributes][Gut_Score]='+r.score;
    window.open(checkoutUrl,'_blank');
  }).catch(()=>{
    // Fallback: direct cart URL
    const url='https://x.sova.health/cart/43980531826822:1'
      +'?note='+encodeURIComponent(fullNote)
      +'&attributes[Customer_Name]='+encodeURIComponent(r.profile?.name||'')
      +'&attributes[Formula_Strains]='+encodeURIComponent(strainListShort)
      +'&attributes[Gut_Score]='+r.score;
    window.open(url,'_blank');
  });
}


function viewResults(){
  try{const r=JSON.parse(sessionStorage.getItem(SS_RES)||'null');if(r&&r.completedAt){showResultsFromData(r);}}catch(e){}
}
function retakeAssessment(){
  if(confirm('Retake the assessment? Your current results will be cleared.')){
    sessionStorage.removeItem(SS_RES);
    sessionStorage.removeItem(SS_KEY);
    QZ={idx:0,answers:{},multiSel:{},botherSel:{}};
    startAssessment();
    // Reset float CTA
    document.getElementById('fct-default').style.display='block';
    document.getElementById('fct-results').style.display='none';
  }
}

// ── SESSION INIT ──
(function initSession(){
  // On page load: check if results exist
  try{
    const res=JSON.parse(sessionStorage.getItem(SS_RES)||'null');
    if(res&&res.completedAt){
      // Show post-result CTAs
      const def=document.getElementById('fct-default');
      const res2=document.getElementById('fct-results');
      if(def)def.style.display='none';
      if(res2)res2.style.display='flex';
      // Also update mobile sticky bar
      const mb=document.getElementById('mobBar');
      if(mb)mb.innerHTML=`<div style="display:flex;gap:8px"><button onclick="retakeAssessment()" style="flex:1;padding:13px 10px;border-radius:var(--r2);background:var(--bg2);border:1.5px solid var(--bdr2);color:var(--text);font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;cursor:pointer">Retake</button><button onclick="viewResults()" style="flex:2;padding:13px;border-radius:var(--r2);background:var(--text);border:none;color:#fff;font-family:'Sora',sans-serif;font-size:13px;font-weight:700;cursor:pointer">View My Formula →</button></div>`;
    }
  }catch(e){}
  // Hash navigation
  window.addEventListener('hashchange',function(){
    if(location.hash==='#assessment')startAssessment();
    if(location.hash==='#results'){
      try{const r=JSON.parse(sessionStorage.getItem(SS_RES)||'null');if(r)showResultsFromData(r);}catch(e){}
    }
  });
  if(location.hash==='#assessment')startAssessment();
  if(location.hash==='#results'){
    try{const r=JSON.parse(sessionStorage.getItem(SS_RES)||'null');if(r)showResultsFromData(r);}catch(e){}
  }
})();